import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _Object$freeze;

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(selection_iterator);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

import * as React from "react";
import React__default, { useRef, useMemo, useEffect, useState, forwardRef, useCallback, useContext } from "react";
import { unstable_batchedUpdates } from "react-dom";

function toVal(mix) {
  var k,
      y,
      str = "";

  if (typeof mix === "string" || typeof mix === "number") {
    str += mix;
  } else if (typeof mix === "object") {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += " ");
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += " ");
          str += k;
        }
      }
    }
  }

  return str;
}

function clsx() {
  var i = 0,
      tmp,
      x,
      str = "";

  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += " ");
        str += x;
      }
    }
  }

  return str;
}

var propTypes = {
  exports: {}
};
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }

    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  }

  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);

  for (var key in definition) {
    prototype[key] = definition[key];
  }

  return prototype;
}

function Color() {}

var _darker = 0.7;

var _brighter = 1 / _darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy: function copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format2) {
  var m2, l;
  format2 = (format2 + "").trim().toLowerCase();
  return (m2 = reHex.exec(format2)) ? (l = m2[1].length, m2 = parseInt(m2[1], 16), l === 6 ? rgbn(m2) : l === 3 ? new Rgb(m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, (m2 & 15) << 4 | m2 & 15, 1) : l === 8 ? rgba$1(m2 >> 24 & 255, m2 >> 16 & 255, m2 >> 8 & 255, (m2 & 255) / 255) : l === 4 ? rgba$1(m2 >> 12 & 15 | m2 >> 8 & 240, m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, ((m2 & 15) << 4 | m2 & 15) / 255) : null) : (m2 = reRgbInteger.exec(format2)) ? new Rgb(m2[1], m2[2], m2[3], 1) : (m2 = reRgbPercent.exec(format2)) ? new Rgb(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, 1) : (m2 = reRgbaInteger.exec(format2)) ? rgba$1(m2[1], m2[2], m2[3], m2[4]) : (m2 = reRgbaPercent.exec(format2)) ? rgba$1(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, m2[4]) : (m2 = reHslPercent.exec(format2)) ? hsla$1(m2[1], m2[2] / 100, m2[3] / 100, 1) : (m2 = reHslaPercent.exec(format2)) ? hsla$1(m2[1], m2[2] / 100, m2[3] / 100, m2[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}

function rgbn(n2) {
  return new Rgb(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}

function rgba$1(r, g2, b, a) {
  if (a <= 0) r = g2 = b = NaN;
  return new Rgb(r, g2, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb$1(r, g2, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g2, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g2, b, opacity) {
  this.r = +r;
  this.g = +g2;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb$1, extend(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity;
  a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla$1(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g2 = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g2, b),
      max = Math.max(r, g2, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;

  if (s) {
    if (r === max) h = (g2 - b) / s + (g2 < b) * 6;else if (g2 === max) h = (b - r) / s + 2;else h = (r - g2) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }

  return new Hsl(h, s, l, o.opacity);
}

function hsl$1(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl$1, extend(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

var radians = Math.PI / 180;
var degrees = 180 / Math.PI;
var A = -0.14861,
    B = 1.78277,
    C = -0.29227,
    D = -0.90649,
    E = 1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g2 = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g2) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g2 - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
      h = s ? Math.atan2(k, bl) * degrees - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix$2(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix$2, extend(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * radians,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
  }
}));

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1,
      t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

function basis$1(values) {
  var n2 = values.length - 1;
  return function (t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n2 - 1) : Math.floor(t * n2),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n2 - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n2) * n2, v0, v1, v2, v3);
  };
}

var constant$1 = function constant$1(x) {
  return function () {
    return x;
  };
};

function linear$1(a, d) {
  return function (t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$1(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function (a, b) {
    return b - a ? exponential(a, b, y) : constant$1(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant$1(isNaN(a) ? b : a);
}

var interpolateRgb = function rgbGamma(y) {
  var color2 = gamma(y);

  function rgb2(start2, end) {
    var r = color2((start2 = rgb$1(start2)).r, (end = rgb$1(end)).r),
        g2 = color2(start2.g, end.g),
        b = color2(start2.b, end.b),
        opacity = nogamma(start2.opacity, end.opacity);
    return function (t) {
      start2.r = r(t);
      start2.g = g2(t);
      start2.b = b(t);
      start2.opacity = opacity(t);
      return start2 + "";
    };
  }

  rgb2.gamma = rgbGamma;
  return rgb2;
}(1);

function rgbSpline(spline) {
  return function (colors2) {
    var n2 = colors2.length,
        r = new Array(n2),
        g2 = new Array(n2),
        b = new Array(n2),
        i,
        color2;

    for (i = 0; i < n2; ++i) {
      color2 = rgb$1(colors2[i]);
      r[i] = color2.r || 0;
      g2[i] = color2.g || 0;
      b[i] = color2.b || 0;
    }

    r = spline(r);
    g2 = spline(g2);
    b = spline(b);
    color2.opacity = 1;
    return function (t) {
      color2.r = r(t);
      color2.g = g2(t);
      color2.b = b(t);
      return color2 + "";
    };
  };
}

var rgbBasis = rgbSpline(basis$1);

function numberArray(a, b) {
  if (!b) b = [];
  var n2 = a ? Math.min(b.length, a.length) : 0,
      c6 = b.slice(),
      i;
  return function (t) {
    for (i = 0; i < n2; ++i) {
      c6[i] = a[i] * (1 - t) + b[i] * t;
    }

    return c6;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c6 = new Array(nb),
      i;

  for (i = 0; i < na; ++i) {
    x[i] = interpolate$1(a[i], b[i]);
  }

  for (; i < nb; ++i) {
    c6[i] = b[i];
  }

  return function (t) {
    for (i = 0; i < na; ++i) {
      c6[i] = x[i](t);
    }

    return c6;
  };
}

function date(a, b) {
  var d = new Date();
  return a = +a, b = +b, function (t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function (t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c6 = {},
      k;
  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolate$1(a[k], b[k]);
    } else {
      c6[k] = b[k];
    }
  }

  return function (t) {
    for (k in i) {
      c6[k] = i[k](t);
    }

    return c6;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function () {
    return b;
  };
}

function one(b) {
  return function (t) {
    return b(t) + "";
  };
}

function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
      am,
      bm,
      bs,
      i = -1,
      s = [],
      q2 = [];
  a = a + "", b = b + "";

  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs;else s[++i] = bs;
    }

    if ((am = am[0]) === (bm = bm[0])) {
      if (s[i]) s[i] += bm;else s[++i] = bm;
    } else {
      s[++i] = null;
      q2.push({
        i: i,
        x: interpolateNumber(am, bm)
      });
    }

    bi = reB.lastIndex;
  }

  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs;else s[++i] = bs;
  }

  return s.length < 2 ? q2[0] ? one(q2[0].x) : zero(b) : (b = q2.length, function (t) {
    for (var i2 = 0, o; i2 < b; ++i2) {
      s[(o = q2[i2]).i] = o.x(t);
    }

    return s.join("");
  });
}

function interpolate$1(a, b) {
  var t = typeof b,
      c6;
  return b == null || t === "boolean" ? constant$1(b) : (t === "number" ? interpolateNumber : t === "string" ? (c6 = color(b)) ? (b = c6, interpolateRgb) : string : b instanceof color ? interpolateRgb : b instanceof Date ? date : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object : interpolateNumber)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function (t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function cubehelix$1(hue2) {
  return function cubehelixGamma(y) {
    y = +y;

    function cubehelix2(start2, end) {
      var h = hue2((start2 = cubehelix$2(start2)).h, (end = cubehelix$2(end)).h),
          s = nogamma(start2.s, end.s),
          l = nogamma(start2.l, end.l),
          opacity = nogamma(start2.opacity, end.opacity);
      return function (t) {
        start2.h = h(t);
        start2.s = s(t);
        start2.l = l(Math.pow(t, y));
        start2.opacity = opacity(t);
        return start2 + "";
      };
    }

    cubehelix2.gamma = cubehelixGamma;
    return cubehelix2;
  }(1);
}

cubehelix$1(hue);
var cubehelixLong = cubehelix$1(nogamma);

function piecewise(interpolate2, values) {
  if (values === void 0) values = interpolate2, interpolate2 = interpolate$1;
  var i = 0,
      n2 = values.length - 1,
      v = values[0],
      I = new Array(n2 < 0 ? 0 : n2);

  while (i < n2) {
    I[i] = interpolate2(v, v = values[++i]);
  }

  return function (t) {
    var i2 = Math.max(0, Math.min(n2 - 1, Math.floor(t *= n2)));
    return I[i2](t - i2);
  };
}

function colors$2(specifier) {
  var n2 = specifier.length / 6 | 0,
      colors2 = new Array(n2),
      i = 0;

  while (i < n2) {
    colors2[i] = "#" + specifier.slice(i * 6, ++i * 6);
  }

  return colors2;
}

var category10 = colors$2("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
var Accent = colors$2("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
var Dark2 = colors$2("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
var Paired = colors$2("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
var Pastel1 = colors$2("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
var Pastel2 = colors$2("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
var Set1 = colors$2("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
var Set2 = colors$2("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
var Set3 = colors$2("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
var Tableau10 = colors$2("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

var ramp$1 = function ramp$1(scheme2) {
  return rgbBasis(scheme2[scheme2.length - 1]);
};

var scheme$q = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors$2);
var BrBG = ramp$1(scheme$q);
var scheme$p = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors$2);
var PRGn = ramp$1(scheme$p);
var scheme$o = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors$2);
var PiYG = ramp$1(scheme$o);
var scheme$n = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors$2);
var PuOr = ramp$1(scheme$n);
var scheme$m = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors$2);
var RdBu = ramp$1(scheme$m);
var scheme$l = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors$2);
var RdGy = ramp$1(scheme$l);
var scheme$k = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors$2);
var RdYlBu = ramp$1(scheme$k);
var scheme$j = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors$2);
var RdYlGn = ramp$1(scheme$j);
var scheme$i = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors$2);
var Spectral = ramp$1(scheme$i);
var scheme$h = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors$2);
var BuGn = ramp$1(scheme$h);
var scheme$g = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors$2);
var BuPu = ramp$1(scheme$g);
var scheme$f = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors$2);
var GnBu = ramp$1(scheme$f);
var scheme$e = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors$2);
var OrRd = ramp$1(scheme$e);
var scheme$d = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors$2);
var PuBuGn = ramp$1(scheme$d);
var scheme$c = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors$2);
var PuBu = ramp$1(scheme$c);
var scheme$b = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors$2);
var PuRd = ramp$1(scheme$b);
var scheme$a = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors$2);
var RdPu = ramp$1(scheme$a);
var scheme$9 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors$2);
var YlGnBu = ramp$1(scheme$9);
var scheme$8 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors$2);
var YlGn = ramp$1(scheme$8);
var scheme$7 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors$2);
var YlOrBr = ramp$1(scheme$7);
var scheme$6 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors$2);
var YlOrRd = ramp$1(scheme$6);
var scheme$5 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors$2);
var Blues = ramp$1(scheme$5);
var scheme$4 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors$2);
var Greens = ramp$1(scheme$4);
var scheme$3 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors$2);
var Greys = ramp$1(scheme$3);
var scheme$2 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors$2);
var Purples = ramp$1(scheme$2);
var scheme$1 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors$2);
var Reds = ramp$1(scheme$1);
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors$2);
var Oranges = ramp$1(scheme);

function cividis(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

var cubehelix = cubehelixLong(cubehelix$2(300, 0.5, 0), cubehelix$2(-240, 0.5, 1));
var warm = cubehelixLong(cubehelix$2(-100, 0.75, 0.35), cubehelix$2(80, 1.5, 0.8));
var cool = cubehelixLong(cubehelix$2(260, 0.75, 0.35), cubehelix$2(80, 1.5, 0.8));
var c$1 = cubehelix$2();

function rainbow(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts2 = Math.abs(t - 0.5);
  c$1.h = 360 * t - 100;
  c$1.s = 1.5 - 1.5 * ts2;
  c$1.l = 0.8 - 0.9 * ts2;
  return c$1 + "";
}

var c = rgb$1(),
    pi_1_3 = Math.PI / 3,
    pi_2_3 = Math.PI * 2 / 3;

function sinebow(t) {
  var x;
  t = (0.5 - t) * Math.PI;
  c.r = 255 * (x = Math.sin(t)) * x;
  c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
  c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
  return c + "";
}

function turbo(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}

function ramp(range) {
  var n2 = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n2 - 1, Math.floor(t * n2)))];
  };
}

var viridis = ramp(colors$2("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp(colors$2("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp(colors$2("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp(colors$2("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
var chromatic = /* @__PURE__ */Object.freeze((_Object$freeze = {
  __proto__: null
}, _defineProperty(_Object$freeze, Symbol.toStringTag, "Module"), _defineProperty(_Object$freeze, "schemeCategory10", category10), _defineProperty(_Object$freeze, "schemeAccent", Accent), _defineProperty(_Object$freeze, "schemeDark2", Dark2), _defineProperty(_Object$freeze, "schemePaired", Paired), _defineProperty(_Object$freeze, "schemePastel1", Pastel1), _defineProperty(_Object$freeze, "schemePastel2", Pastel2), _defineProperty(_Object$freeze, "schemeSet1", Set1), _defineProperty(_Object$freeze, "schemeSet2", Set2), _defineProperty(_Object$freeze, "schemeSet3", Set3), _defineProperty(_Object$freeze, "schemeTableau10", Tableau10), _defineProperty(_Object$freeze, "interpolateBrBG", BrBG), _defineProperty(_Object$freeze, "schemeBrBG", scheme$q), _defineProperty(_Object$freeze, "interpolatePRGn", PRGn), _defineProperty(_Object$freeze, "schemePRGn", scheme$p), _defineProperty(_Object$freeze, "interpolatePiYG", PiYG), _defineProperty(_Object$freeze, "schemePiYG", scheme$o), _defineProperty(_Object$freeze, "interpolatePuOr", PuOr), _defineProperty(_Object$freeze, "schemePuOr", scheme$n), _defineProperty(_Object$freeze, "interpolateRdBu", RdBu), _defineProperty(_Object$freeze, "schemeRdBu", scheme$m), _defineProperty(_Object$freeze, "interpolateRdGy", RdGy), _defineProperty(_Object$freeze, "schemeRdGy", scheme$l), _defineProperty(_Object$freeze, "interpolateRdYlBu", RdYlBu), _defineProperty(_Object$freeze, "schemeRdYlBu", scheme$k), _defineProperty(_Object$freeze, "interpolateRdYlGn", RdYlGn), _defineProperty(_Object$freeze, "schemeRdYlGn", scheme$j), _defineProperty(_Object$freeze, "interpolateSpectral", Spectral), _defineProperty(_Object$freeze, "schemeSpectral", scheme$i), _defineProperty(_Object$freeze, "interpolateBuGn", BuGn), _defineProperty(_Object$freeze, "schemeBuGn", scheme$h), _defineProperty(_Object$freeze, "interpolateBuPu", BuPu), _defineProperty(_Object$freeze, "schemeBuPu", scheme$g), _defineProperty(_Object$freeze, "interpolateGnBu", GnBu), _defineProperty(_Object$freeze, "schemeGnBu", scheme$f), _defineProperty(_Object$freeze, "interpolateOrRd", OrRd), _defineProperty(_Object$freeze, "schemeOrRd", scheme$e), _defineProperty(_Object$freeze, "interpolatePuBuGn", PuBuGn), _defineProperty(_Object$freeze, "schemePuBuGn", scheme$d), _defineProperty(_Object$freeze, "interpolatePuBu", PuBu), _defineProperty(_Object$freeze, "schemePuBu", scheme$c), _defineProperty(_Object$freeze, "interpolatePuRd", PuRd), _defineProperty(_Object$freeze, "schemePuRd", scheme$b), _defineProperty(_Object$freeze, "interpolateRdPu", RdPu), _defineProperty(_Object$freeze, "schemeRdPu", scheme$a), _defineProperty(_Object$freeze, "interpolateYlGnBu", YlGnBu), _defineProperty(_Object$freeze, "schemeYlGnBu", scheme$9), _defineProperty(_Object$freeze, "interpolateYlGn", YlGn), _defineProperty(_Object$freeze, "schemeYlGn", scheme$8), _defineProperty(_Object$freeze, "interpolateYlOrBr", YlOrBr), _defineProperty(_Object$freeze, "schemeYlOrBr", scheme$7), _defineProperty(_Object$freeze, "interpolateYlOrRd", YlOrRd), _defineProperty(_Object$freeze, "schemeYlOrRd", scheme$6), _defineProperty(_Object$freeze, "interpolateBlues", Blues), _defineProperty(_Object$freeze, "schemeBlues", scheme$5), _defineProperty(_Object$freeze, "interpolateGreens", Greens), _defineProperty(_Object$freeze, "schemeGreens", scheme$4), _defineProperty(_Object$freeze, "interpolateGreys", Greys), _defineProperty(_Object$freeze, "schemeGreys", scheme$3), _defineProperty(_Object$freeze, "interpolatePurples", Purples), _defineProperty(_Object$freeze, "schemePurples", scheme$2), _defineProperty(_Object$freeze, "interpolateReds", Reds), _defineProperty(_Object$freeze, "schemeReds", scheme$1), _defineProperty(_Object$freeze, "interpolateOranges", Oranges), _defineProperty(_Object$freeze, "schemeOranges", scheme), _defineProperty(_Object$freeze, "interpolateCividis", cividis), _defineProperty(_Object$freeze, "interpolateCubehelixDefault", cubehelix), _defineProperty(_Object$freeze, "interpolateRainbow", rainbow), _defineProperty(_Object$freeze, "interpolateWarm", warm), _defineProperty(_Object$freeze, "interpolateCool", cool), _defineProperty(_Object$freeze, "interpolateSinebow", sinebow), _defineProperty(_Object$freeze, "interpolateTurbo", turbo), _defineProperty(_Object$freeze, "interpolateViridis", viridis), _defineProperty(_Object$freeze, "interpolateMagma", magma), _defineProperty(_Object$freeze, "interpolateInferno", inferno), _defineProperty(_Object$freeze, "interpolatePlasma", plasma), _Object$freeze));

function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector(f2) {
  var delta = f2;
  var compare = f2;

  if (f2.length === 1) {
    delta = function delta(d, x) {
      return f2(d) - x;
    };

    compare = ascendingComparator(f2);
  }

  function left2(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;

    while (lo < hi) {
      var mid = lo + hi >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
    }

    return lo;
  }

  function right2(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;

    while (lo < hi) {
      var mid = lo + hi >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
    }

    return lo;
  }

  function center2(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    var i = left2(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {
    left: left2,
    center: center2,
    right: right2
  };
}

function ascendingComparator(f2) {
  return function (d, x) {
    return ascending$1(f2(d), x);
  };
}

function number$2(x) {
  return x === null ? NaN : +x;
}

var ascendingBisect = bisector(ascending$1);
var bisectRight = ascendingBisect.right;
bisector(number$2).center;
var bisect = bisectRight;

function extent(values, valueof) {
  var min;
  var max;

  if (valueof === void 0) {
    var _iterator3 = _createForOfIteratorHelper(values),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var value = _step3.value;

        if (value != null) {
          if (min === void 0) {
            if (value >= value) min = max = value;
          } else {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  } else {
    var index = -1;

    var _iterator4 = _createForOfIteratorHelper(values),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _value2 = _step4.value;

        if ((_value2 = valueof(_value2, ++index, values)) != null) {
          if (min === void 0) {
            if (_value2 >= _value2) min = max = _value2;
          } else {
            if (min > _value2) min = _value2;
            if (max < _value2) max = _value2;
          }
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return [min, max];
}

var InternMap = /*#__PURE__*/function (_Map) {
  _inherits(InternMap, _Map);

  var _super = _createSuper(InternMap);

  function InternMap(entries) {
    var _this;

    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : keyof;

    _classCallCheck(this, InternMap);

    _this = _super.call(this);
    Object.defineProperties(_assertThisInitialized(_this), {
      _intern: {
        value: /* @__PURE__ */new Map()
      },
      _key: {
        value: key
      }
    });

    if (entries != null) {
      var _iterator5 = _createForOfIteratorHelper(entries),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              key2 = _step5$value[0],
              value = _step5$value[1];

          _this.set(key2, value);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }

    return _this;
  }

  _createClass(InternMap, [{
    key: "get",
    value: function get(key) {
      return _get(_getPrototypeOf(InternMap.prototype), "get", this).call(this, intern_get(this, key));
    }
  }, {
    key: "has",
    value: function has(key) {
      return _get(_getPrototypeOf(InternMap.prototype), "has", this).call(this, intern_get(this, key));
    }
  }, {
    key: "set",
    value: function set(key, value) {
      return _get(_getPrototypeOf(InternMap.prototype), "set", this).call(this, intern_set(this, key), value);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      return _get(_getPrototypeOf(InternMap.prototype), "delete", this).call(this, intern_delete(this, key));
    }
  }]);

  return InternMap;
}( /*#__PURE__*/_wrapNativeSuper(Map));

function intern_get(_ref2, value) {
  var _intern = _ref2._intern,
      _key = _ref2._key;

  var key = _key(value);

  return _intern.has(key) ? _intern.get(key) : value;
}

function intern_set(_ref3, value) {
  var _intern = _ref3._intern,
      _key = _ref3._key;

  var key = _key(value);

  if (_intern.has(key)) return _intern.get(key);

  _intern.set(key, value);

  return value;
}

function intern_delete(_ref4, value) {
  var _intern = _ref4._intern,
      _key = _ref4._key;

  var key = _key(value);

  if (_intern.has(key)) {
    value = _intern.get(value);

    _intern.delete(key);
  }

  return value;
}

function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}

function identity$3(x) {
  return x;
}

function group(values) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
    keys[_key2 - 1] = arguments[_key2];
  }

  return nest(values, identity$3, identity$3, keys);
}

function nest(values, map2, reduce, keys) {
  return function regroup(values2, i) {
    if (i >= keys.length) return reduce(values2);
    var groups = new InternMap();
    var keyof2 = keys[i++];
    var index = -1;

    var _iterator6 = _createForOfIteratorHelper(values2),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var value = _step6.value;
        var key = keyof2(value, ++index, values2);
        var group2 = groups.get(key);
        if (group2) group2.push(value);else groups.set(key, [value]);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    var _iterator7 = _createForOfIteratorHelper(groups),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _step7$value = _slicedToArray(_step7.value, 2),
            _key3 = _step7$value[0],
            values3 = _step7$value[1];

        groups.set(_key3, regroup(values3, i));
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    return map2(groups);
  }(values, 0);
}

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks(start2, stop2, count) {
  var reverse,
      i = -1,
      n2,
      ticks2,
      step;
  stop2 = +stop2, start2 = +start2, count = +count;
  if (start2 === stop2 && count > 0) return [start2];
  if (reverse = stop2 < start2) n2 = start2, start2 = stop2, stop2 = n2;
  if ((step = tickIncrement(start2, stop2, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    var r0 = Math.round(start2 / step),
        r1 = Math.round(stop2 / step);
    if (r0 * step < start2) ++r0;
    if (r1 * step > stop2) --r1;
    ticks2 = new Array(n2 = r1 - r0 + 1);

    while (++i < n2) {
      ticks2[i] = (r0 + i) * step;
    }
  } else {
    step = -step;

    var _r = Math.round(start2 * step),
        _r2 = Math.round(stop2 * step);

    if (_r / step < start2) ++_r;
    if (_r2 / step > stop2) --_r2;
    ticks2 = new Array(n2 = _r2 - _r + 1);

    while (++i < n2) {
      ticks2[i] = (_r + i) / step;
    }
  }

  if (reverse) ticks2.reverse();
  return ticks2;
}

function tickIncrement(start2, stop2, count) {
  var step = (stop2 - start2) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start2, stop2, count) {
  var step0 = Math.abs(stop2 - start2) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;else if (error >= e5) step1 *= 5;else if (error >= e2) step1 *= 2;
  return stop2 < start2 ? -step1 : step1;
}

function quantileSorted(values, p2) {
  var valueof = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : number$2;
  if (!(n2 = values.length)) return;
  if ((p2 = +p2) <= 0 || n2 < 2) return +valueof(values[0], 0, values);
  if (p2 >= 1) return +valueof(values[n2 - 1], n2 - 1, values);
  var n2,
      i = (n2 - 1) * p2,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}

function sequence(start2, stop2, step) {
  start2 = +start2, stop2 = +stop2, step = (n2 = arguments.length) < 2 ? (stop2 = start2, start2 = 0, 1) : n2 < 3 ? 1 : +step;
  var i = -1,
      n2 = Math.max(0, Math.ceil((stop2 - start2) / step)) | 0,
      range = new Array(n2);

  while (++i < n2) {
    range[i] = start2 + i * step;
  }

  return range;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0:
      break;

    case 1:
      this.range(domain);
      break;

    default:
      this.range(range).domain(domain);
      break;
  }

  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;

    case 1:
      {
        if (typeof domain === "function") this.interpolator(domain);else this.range(domain);
        break;
      }

    default:
      {
        this.domain(domain);
        if (typeof interpolator === "function") this.interpolator(interpolator);else this.range(interpolator);
        break;
      }
  }

  return this;
}

var implicit = Symbol("implicit");

function ordinal() {
  var index = /* @__PURE__ */new Map(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "",
        i = index.get(key);

    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }

    return range[(i - 1) % range.length];
  }

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = /* @__PURE__ */new Map();

    var _iterator8 = _createForOfIteratorHelper(_),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var value = _step8.value;
        var key = value + "";
        if (index.has(key)) continue;
        index.set(key, domain.push(value));
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }

    return scale;
  };

  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);
  return scale;
}

function band() {
  var scale = ordinal().unknown(void 0),
      domain = scale.domain,
      ordinalRange = scale.range,
      r0 = 0,
      r1 = 1,
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;
  delete scale.unknown;

  function rescale() {
    var n2 = domain().length,
        reverse = r1 < r0,
        start2 = reverse ? r1 : r0,
        stop2 = reverse ? r0 : r1;
    step = (stop2 - start2) / Math.max(1, n2 - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start2 += (stop2 - start2 - step * (n2 - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start2 = Math.round(start2), bandwidth = Math.round(bandwidth);
    var values = sequence(n2).map(function (i) {
      return start2 + step * i;
    });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function (_) {
    var _ref5;

    return arguments.length ? ((_ref5 = _slicedToArray(_, 2), r0 = _ref5[0], r1 = _ref5[1]), r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };

  scale.rangeRound = function (_) {
    var _ref6;

    return (_ref6 = _slicedToArray(_, 2), r0 = _ref6[0], r1 = _ref6[1]), r0 = +r0, r1 = +r1, round = true, rescale();
  };

  scale.bandwidth = function () {
    return bandwidth;
  };

  scale.step = function () {
    return step;
  };

  scale.round = function (_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function (_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function (_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function (_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function (_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function () {
    return band(domain(), [r0, r1]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function constants(x) {
  return function () {
    return x;
  };
}

function number$1(x) {
  return +x;
}

var unit = [0, 1];

function identity$2(x) {
  return x;
}

function normalize(a, b) {
  return (b -= a = +a) ? function (x) {
    return (x - a) / b;
  } : constants(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function (x) {
    return Math.max(a, Math.min(b, x));
  };
}

function bimap(domain, range, interpolate2) {
  var d0 = domain[0],
      d1 = domain[1],
      r0 = range[0],
      r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate2(r1, r0);else d0 = normalize(d0, d1), r0 = interpolate2(r0, r1);
  return function (x) {
    return r0(d0(x));
  };
}

function polymap(domain, range, interpolate2) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate2(range[i], range[i + 1]);
  }

  return function (x) {
    var i2 = bisect(domain, x, 1, j) - 1;
    return r[i2](d[i2](x));
  };
}

function copy$1(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}

function transformer$1() {
  var domain = unit,
      range = unit,
      interpolate2 = interpolate$1,
      transform,
      untransform,
      unknown,
      clamp = identity$2,
      piecewise2,
      output,
      input;

  function rescale() {
    var n2 = Math.min(domain.length, range.length);
    if (clamp !== identity$2) clamp = clamper(domain[0], domain[n2 - 1]);
    piecewise2 = n2 > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise2(domain.map(transform), range, interpolate2)))(transform(clamp(x)));
  }

  scale.invert = function (y) {
    return clamp(untransform((input || (input = piecewise2(range, domain.map(transform), interpolateNumber)))(y)));
  };

  scale.domain = function (_) {
    return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function (_) {
    return range = Array.from(_), interpolate2 = interpolateRound, rescale();
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = _ ? true : identity$2, rescale()) : clamp !== identity$2;
  };

  scale.interpolate = function (_) {
    return arguments.length ? (interpolate2 = _, rescale()) : interpolate2;
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function (t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer$1()(identity$2, identity$2);
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}

function formatDecimalParts(x, p2) {
  if ((i = (x = p2 ? x.toExponential(p2 - 1) : x.toExponential()).indexOf("e")) < 0) return null;
  var i,
      coefficient = x.slice(0, i);
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function (value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g2 = grouping[0],
        length = 0;

    while (i > 0 && g2 > 0) {
      if (length + g2 + 1 > width) g2 = Math.max(1, width - length);
      t.push(value.substring(i -= g2, i + g2));
      if ((length += g2 + 1) > width) break;
      g2 = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
}

var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype;

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

function formatTrim(s) {
  out: for (var n2 = s.length, i = 1, i0 = -1, i1; i < n2; ++i) {
    switch (s[i]) {
      case ".":
        i0 = i1 = i;
        break;

      case "0":
        if (i0 === 0) i0 = i;
        i1 = i;
        break;

      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }

  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p2) {
  var d = formatDecimalParts(x, p2);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent2 = d[1],
      i = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1,
      n2 = coefficient.length;
  return i === n2 ? coefficient : i > n2 ? coefficient + new Array(i - n2 + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p2 + i - 1))[0];
}

function formatRounded(x, p2) {
  var d = formatDecimalParts(x, p2);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent2 = d[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": function _(x, p2) {
    return (x * 100).toFixed(p2);
  },
  "b": function b(x) {
    return Math.round(x).toString(2);
  },
  "c": function c(x) {
    return x + "";
  },
  "d": formatDecimal,
  "e": function e(x, p2) {
    return x.toExponential(p2);
  },
  "f": function f(x, p2) {
    return x.toFixed(p2);
  },
  "g": function g(x, p2) {
    return x.toPrecision(p2);
  },
  "o": function o(x) {
    return Math.round(x).toString(8);
  },
  "p": function p(x, p2) {
    return formatRounded(x * 100, p2);
  },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function X(x) {
    return Math.round(x).toString(16).toUpperCase();
  },
  "x": function x(_x) {
    return Math.round(_x).toString(16);
  }
};

function identity$1(x) {
  return x;
}

var map = Array.prototype.map,
    prefixes$1 = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

function formatLocale(locale2) {
  var group2 = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$1 : formatGroup(map.call(locale2.grouping, Number), locale2.thousands + ""),
      currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "",
      currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "",
      decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "",
      numerals = locale2.numerals === void 0 ? identity$1 : formatNumerals(map.call(locale2.numerals, String)),
      percent = locale2.percent === void 0 ? "%" : locale2.percent + "",
      minus = locale2.minus === void 0 ? "\u2212" : locale2.minus + "",
      nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero2 = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;
    if (type === "n") comma = true, type = "g";else if (!formatTypes[type]) precision === void 0 && (precision = 12), trim = true, type = "g";
    if (zero2 || fill === "0" && align === "=") zero2 = true, fill = "0", align = "=";
    var prefix2 = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));

    function format2(value) {
      var valuePrefix = prefix2,
          valueSuffix = suffix,
          i,
          n2,
          c6;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim) value = formatTrim(value);
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
        valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes$1[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        if (maybeSuffix) {
          i = -1, n2 = value.length;

          while (++i < n2) {
            if (c6 = value.charCodeAt(i), 48 > c6 || c6 > 57) {
              valueSuffix = (c6 === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      if (comma && !zero2) value = group2(value, Infinity);
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";
      if (comma && zero2) value = group2(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;

        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;

        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;

        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }

      return numerals(value);
    }

    format2.toString = function () {
      return specifier + "";
    };

    return format2;
  }

  function formatPrefix2(specifier, value) {
    var f2 = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix2 = prefixes$1[8 + e / 3];
    return function (value2) {
      return f2(k * value2) + prefix2;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}

var locale;
var format;
var formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function tickFormat(start2, stop2, count, specifier) {
  var step = tickStep(start2, stop2, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);

  switch (specifier.type) {
    case "s":
      {
        var value = Math.max(Math.abs(start2), Math.abs(stop2));
        if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
        return formatPrefix(specifier, value);
      }

    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      {
        if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start2), Math.abs(stop2))))) specifier.precision = precision - (specifier.type === "e");
        break;
      }

    case "f":
    case "%":
      {
        if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
        break;
      }
  }

  return format(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function (count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function (count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function (count) {
    if (count == null) count = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start2 = d[i0];
    var stop2 = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop2 < start2) {
      step = start2, start2 = stop2, stop2 = step;
      step = i0, i0 = i1, i1 = step;
    }

    while (maxIter-- > 0) {
      step = tickIncrement(start2, stop2, count);

      if (step === prestep) {
        d[i0] = start2;
        d[i1] = stop2;
        return domain(d);
      } else if (step > 0) {
        start2 = Math.floor(start2 / step) * step;
        stop2 = Math.ceil(stop2 / step) * step;
      } else if (step < 0) {
        start2 = Math.ceil(start2 * step) / step;
        stop2 = Math.floor(stop2 * step) / step;
      } else {
        break;
      }

      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous();

  scale.copy = function () {
    return copy$1(scale, linear());
  };

  initRange.apply(scale, arguments);
  return linearish(scale);
}

function quantile() {
  var domain = [],
      range = [],
      thresholds = [],
      unknown;

  function rescale() {
    var i = 0,
        n2 = Math.max(1, range.length);
    thresholds = new Array(n2 - 1);

    while (++i < n2) {
      thresholds[i - 1] = quantileSorted(domain, i / n2);
    }

    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : range[bisect(thresholds, x)];
  }

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [i > 0 ? thresholds[i - 1] : domain[0], i < thresholds.length ? thresholds[i] : domain[domain.length - 1]];
  };

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [];

    var _iterator9 = _createForOfIteratorHelper(_),
        _step9;

    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var d = _step9.value;
        if (d != null && !isNaN(d = +d)) domain.push(d);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }

    domain.sort(ascending$1);
    return rescale();
  };

  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.quantiles = function () {
    return thresholds.slice();
  };

  scale.copy = function () {
    return quantile().domain(domain).range(range).unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

function quantize() {
  var x0 = 0,
      x1 = 1,
      n2 = 1,
      domain = [0.5],
      range = [0, 1],
      unknown;

  function scale(x) {
    return x != null && x <= x ? range[bisect(domain, x, 0, n2)] : unknown;
  }

  function rescale() {
    var i = -1;
    domain = new Array(n2);

    while (++i < n2) {
      domain[i] = ((i + 1) * x1 - (i - n2) * x0) / (n2 + 1);
    }

    return scale;
  }

  scale.domain = function (_) {
    var _ref7;

    return arguments.length ? ((_ref7 = _slicedToArray(_, 2), x0 = _ref7[0], x1 = _ref7[1]), x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
  };

  scale.range = function (_) {
    return arguments.length ? (n2 = (range = Array.from(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n2 ? [domain[n2 - 1], x1] : [domain[i - 1], domain[i]];
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };

  scale.thresholds = function () {
    return domain.slice();
  };

  scale.copy = function () {
    return quantize().domain([x0, x1]).range(range).unknown(unknown);
  };

  return initRange.apply(linearish(scale), arguments);
}

function threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n2 = 1;

  function scale(x) {
    return x != null && x <= x ? range[bisect(domain, x, 0, n2)] : unknown;
  }

  scale.domain = function (_) {
    return arguments.length ? (domain = Array.from(_), n2 = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), n2 = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return threshold().domain(domain).range(range).unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

function transformer() {
  var x0 = 0,
      x1 = 1,
      t0,
      t1,
      k10,
      transform,
      interpolator = identity$2,
      clamp = false,
      unknown;

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function (_) {
    var _ref8;

    return arguments.length ? ((_ref8 = _slicedToArray(_, 2), x0 = _ref8[0], x1 = _ref8[1]), t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  function range(interpolate2) {
    return function (_) {
      var _ref9;

      var r0, r1;
      return arguments.length ? ((_ref9 = _slicedToArray(_, 2), r0 = _ref9[0], r1 = _ref9[1]), interpolator = interpolate2(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }

  scale.range = range(interpolate$1);
  scale.rangeRound = range(interpolateRound);

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function (t) {
    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
    return scale;
  };
}

function copy(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}

function sequential() {
  var scale = linearish(transformer()(identity$2));

  scale.copy = function () {
    return copy(scale, sequential());
  };

  return initInterpolator.apply(scale, arguments);
}

var getGroups = function getGroups(data, selector2) {
  return Array.from(group(data, selector2).keys());
};

var getExtent = function getExtent(data, _ref10) {
  var min = _ref10.min,
      max = _ref10.max,
      _ref10$accessor = _ref10.accessor,
      accessor = _ref10$accessor === void 0 ? function (d) {
    return d;
  } : _ref10$accessor;
  if (Number.isFinite(min) && Number.isFinite(max)) return [min, max];
  if (!data || data.length === 0) return [min || 0, max || 1];
  var dataExtent = extent(data, accessor);
  return [min || dataExtent[0], max || dataExtent[1]];
};

var getDomain = function getDomain(_ref11) {
  var data = _ref11.data,
      accessor = _ref11.accessor,
      min = _ref11.min,
      max = _ref11.max;

  if (data && data.length > 0) {
    var _extent = extent(data, accessor),
        _extent2 = _slicedToArray(_extent, 2),
        dataMin = _extent2[0],
        dataMax = _extent2[1];

    return [min || dataMin, max || dataMax];
  }

  return [min, max];
};

var getColorScale = function getColorScale(type, domain, colors2) {
  if (!Array.isArray(domain)) throw new Error("must provide domain for color scale");

  switch (type) {
    case "quantile":
      return quantile().domain(domain).range(colors2);

    case "quantize":
      return quantize().domain(domain).range(colors2);

    case "threshold":
      return threshold().domain(domain).range(colors2);

    case "category":
      return ordinal().domain(domain).range(colors2);

    case "linear":
      return linear().domain(domain).range(colors2);

    case "sequential":
      var interpolator = getColorInterpolator(colors2);
      return sequential(interpolator).domain(domain);

    default:
      throw new Error("invalid scale type for color scale");
  }
};

var getPositionScale = function getPositionScale(type, domain, range) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (!Array.isArray(domain) || !Array.isArray(range)) throw new Error("must provide domain and range for position scale");
  var scale;

  switch (type) {
    case "category":
      scale = band().domain(domain).range(range);
      break;

    case "quantile":
    case "threshold":
    case "linear":
      scale = linear().domain(extent(domain)).range(range).clamp(true);
      break;

    default:
      scale = linear().domain(domain).range(range).clamp(true);
      break;
  }

  return options.nice ? scale.nice() : scale;
};

var getCategoryChunks = function getCategoryChunks(_ref12) {
  var positionScale = _ref12.positionScale,
      colorScale = _ref12.colorScale;
  return colorScale.domain().map(function (d) {
    return {
      value: d,
      x: positionScale(d),
      width: positionScale.bandwidth(),
      color: colorScale(d)
    };
  });
};

var getChunks = function getChunks(_ref13) {
  var positionScale = _ref13.positionScale,
      colorScale = _ref13.colorScale,
      reverse = _ref13.reverse;
  var scaleCuts = colorScale.thresholds ? colorScale.thresholds() : colorScale.quantiles ? colorScale.quantiles() : colorScale.domain();
  var limits = [positionScale.domain()[0]].concat(_toConsumableArray(scaleCuts), [positionScale.domain()[1]]);
  var boxLimits = limits.slice(0, limits.length - 1).map(function (d, j) {
    return [limits[j], limits[j + 1]];
  });
  return boxLimits.map(function (l, k) {
    return {
      value: [l[0], l[1]],
      x: positionScale(l[!!reverse ? 1 : 0]),
      width: Math.abs(positionScale(l[1]) - positionScale(l[0])),
      color: colorScale.range()[k]
    };
  });
};

var getColorInterpolator = function getColorInterpolator(value) {
  var interpolate2;
  if (Array.isArray(value)) interpolate2 = piecewise(interpolateRgb.gamma(2.2), value);
  if (typeof value === "string" && chromatic["interpolate".concat(value)]) interpolate2 = chromatic["interpolate".concat(value)];
  if (!interpolate2) throw new Error("cannot create colors");
  return interpolate2;
};

var getColors = function getColors(value, numColors) {
  var interpolate2 = getColorInterpolator(value);
  var colors2 = [];

  for (var i = 0; i < numColors; ++i) {
    colors2.push(rgb$1(interpolate2(i / (numColors - 1))).formatHex());
  }

  return colors2;
};

var getCategoryScale = function getCategoryScale(_ref14) {
  var data = _ref14.data,
      categories = _ref14.categories,
      _ref14$colors = _ref14.colors,
      colors2 = _ref14$colors === void 0 ? "YlGnBu" : _ref14$colors,
      accessor = _ref14.accessor,
      sorter = _ref14.sorter;
  if ((!data || data.length === 0) && !categories) throw new Error("must provide data or categories option for category scale");
  categories = categories || getGroups(data, accessor).sort(sorter);
  var scaleColors = getColors(colors2, categories.length);
  var positionScale = getPositionScale("category", categories, [0, 1]);
  var colorScale = getColorScale("category", categories, scaleColors);
  return {
    position: positionScale,
    color: colorScale,
    chunks: getCategoryChunks({
      positionScale: positionScale,
      colorScale: colorScale
    })
  };
};

var getContinuousScale = function getContinuousScale(_ref15) {
  var data = _ref15.data,
      _ref15$colors = _ref15.colors,
      colors2 = _ref15$colors === void 0 ? "YlGnBu" : _ref15$colors,
      nice = _ref15.nice,
      accessor = _ref15.accessor,
      min = _ref15.min,
      max = _ref15.max,
      _ref15$reverse = _ref15.reverse,
      reverse = _ref15$reverse === void 0 ? false : _ref15$reverse;
  var domain = getDomain({
    data: data,
    accessor: accessor,
    min: min,
    max: max,
    reverse: reverse
  });
  var range = !!reverse ? [1, 0] : [0, 1];
  var positionScale = getPositionScale("linear", domain, range, {
    nice: nice
  });
  var colorScale = getColorScale("sequential", domain, colors2);
  return {
    position: positionScale,
    color: colorScale
  };
};

var getQuantileScale = function getQuantileScale(_ref16) {
  var data = _ref16.data,
      _ref16$colors = _ref16.colors,
      colors2 = _ref16$colors === void 0 ? "YlGnBu" : _ref16$colors,
      _ref16$chunks = _ref16.chunks,
      chunks = _ref16$chunks === void 0 ? 5 : _ref16$chunks,
      nice = _ref16.nice,
      accessor = _ref16.accessor,
      _ref16$reverse = _ref16.reverse,
      reverse = _ref16$reverse === void 0 ? false : _ref16$reverse;
  if (!data || !data.length) throw new Error("no data provided for quantile scale");
  var values = accessor ? data.map(accessor) : data;
  var scaleColors = getColors(colors2, chunks);
  var range = !!reverse ? [1, 0] : [0, 1];
  var positionScale = getPositionScale("quantile", values, range, {
    nice: nice
  });
  var colorScale = getColorScale("quantile", values, scaleColors);
  var quantileScale = quantile().domain(values).range(new Array(chunks).fill(1).map(function (v, i) {
    return i;
  }));
  return {
    quantile: quantileScale,
    position: positionScale,
    color: colorScale,
    chunks: getChunks({
      positionScale: positionScale,
      colorScale: colorScale,
      reverse: reverse
    })
  };
};

var getThresholdScale = function getThresholdScale(_ref17) {
  var thresholds = _ref17.thresholds,
      data = _ref17.data,
      accessor = _ref17.accessor,
      _ref17$colors = _ref17.colors,
      colors2 = _ref17$colors === void 0 ? "YlGnBu" : _ref17$colors,
      nice = _ref17.nice,
      min = _ref17.min,
      max = _ref17.max,
      _ref17$reverse = _ref17.reverse,
      reverse = _ref17$reverse === void 0 ? false : _ref17$reverse;
  if (!thresholds || !thresholds.length) throw new Error("must provide thresholds config array for threshold scale");
  var domain = getDomain({
    data: data,
    accessor: accessor,
    min: min,
    max: max
  });
  var scaleColors = getColors(colors2, thresholds.length + 1);
  var colorScale = getColorScale("threshold", thresholds, scaleColors);
  var range = !!reverse ? [1, 0] : [0, 1];
  var positionScale = getPositionScale("threshold", domain, range, {
    nice: nice
  });
  var thresholdScale = threshold().domain(thresholds).range(new Array(thresholds.length + 1).fill(1).map(function (v, i) {
    return i;
  }));
  return {
    threshold: thresholdScale,
    position: positionScale,
    color: colorScale,
    chunks: getChunks({
      positionScale: positionScale,
      colorScale: colorScale,
      reverse: reverse
    })
  };
};

var getQuantizeScale = function getQuantizeScale(_ref18) {
  var data = _ref18.data,
      _ref18$colors = _ref18.colors,
      colors2 = _ref18$colors === void 0 ? "YlGnBu" : _ref18$colors,
      _ref18$chunks = _ref18.chunks,
      chunks = _ref18$chunks === void 0 ? 5 : _ref18$chunks,
      nice = _ref18.nice,
      accessor = _ref18.accessor,
      min = _ref18.min,
      max = _ref18.max,
      _ref18$reverse = _ref18.reverse,
      reverse = _ref18$reverse === void 0 ? false : _ref18$reverse;
  var domain = getDomain({
    data: data,
    accessor: accessor,
    min: min,
    max: max
  });
  var scaleColors = getColors(colors2, chunks);
  var range = !!reverse ? [1, 0] : [0, 1];
  var positionScale = getPositionScale("quantize", domain, range, {
    nice: nice
  });
  var colorScale = getColorScale("quantize", positionScale.domain(), scaleColors);
  var quantizeScale = quantize().domain(positionScale.domain()).range(new Array(chunks).fill(1).map(function (v, i) {
    return i;
  }));
  return {
    quantize: quantizeScale,
    position: positionScale,
    color: colorScale,
    chunks: getChunks({
      positionScale: positionScale,
      colorScale: colorScale,
      reverse: reverse
    })
  };
};

var getBubbleSizes = function getBubbleSizes(minSize, maxSize, count) {
  var sizes = [];
  var sizeRange = maxSize - minSize;
  var sizeStep = sizeRange / (count - 1);

  for (var i = 0; i < count; i++) {
    sizes.push(minSize + i * sizeStep);
  }

  return sizes.map(function (s) {
    return s / 2;
  });
};

var getBubbleScale = function getBubbleScale(_ref19) {
  var data = _ref19.data,
      _ref19$colors = _ref19.colors,
      colors2 = _ref19$colors === void 0 ? "YlGnBu" : _ref19$colors,
      _ref19$chunks = _ref19.chunks,
      chunks = _ref19$chunks === void 0 ? 5 : _ref19$chunks,
      nice = _ref19.nice,
      accessor = _ref19.accessor,
      min = _ref19.min,
      max = _ref19.max,
      _ref19$minSize = _ref19.minSize,
      minSize = _ref19$minSize === void 0 ? 8 : _ref19$minSize,
      _ref19$maxSize = _ref19.maxSize,
      maxSize = _ref19$maxSize === void 0 ? 48 : _ref19$maxSize;
  var domain = getDomain({
    data: data,
    accessor: accessor,
    min: min,
    max: max
  });
  var positionScale = getPositionScale("linear", domain, [0, 1], {
    nice: nice
  });
  var colorScale = getColorScale("sequential", domain, colors2);
  var sizeScale = getPositionScale("linear", domain, [minSize, maxSize]);
  return {
    position: positionScale,
    color: colorScale,
    size: sizeScale,
    chunks: getBubbleSizes(minSize, maxSize, chunks)
  };
};

var getScale = function getScale(type, options) {
  switch (type) {
    case "category":
      return getCategoryScale(options);

    case "quantile":
      return getQuantileScale(options);

    case "threshold":
      return getThresholdScale(options);

    case "quantize":
      return getQuantizeScale(options);

    case "continuous":
      return getContinuousScale(options);

    case "bubble":
      return getBubbleScale(options);

    default:
      throw new Error("unsupported scale type: ".concat(type));
  }
};

var isContinuous = function isContinuous(type) {
  return type === "continuous";
};

var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    var test1 = new String("abc");
    test1[5] = "de";

    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }

    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n2) {
      return test2[n2];
    });

    if (order2.join("") !== "0123456789") {
      return false;
    }

    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }

    return true;
  } catch (err) {
    return false;
  }
}

shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to2 = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to2[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to2[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to2;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f = React__default,
    g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;

if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}

var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    n = Object.prototype.hasOwnProperty,
    p = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

function q(c6, a, k) {
  var b,
      d = {},
      e = null,
      l = null;
  k !== void 0 && (e = "" + k);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (l = a.ref);

  for (b in a) {
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  }

  if (c6 && c6.defaultProps) for (b in a = c6.defaultProps, a) {
    d[b] === void 0 && (d[b] = a[b]);
  }
  return {
    $$typeof: g,
    type: c6,
    key: e,
    ref: l,
    props: d,
    _owner: m.current
  };
}

reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
var jsx = jsxRuntime.exports.jsx;
var jsxs = jsxRuntime.exports.jsxs;

var ContinuousColorScale = function ContinuousColorScale(_a) {
  var _b = _a,
      schemaName = _b.colors,
      _b$points = _b.points,
      points = _b$points === void 0 ? 256 : _b$points,
      _b$width = _b.width,
      width = _b$width === void 0 ? 200 : _b$width,
      _b$height = _b.height,
      height = _b$height === void 0 ? 12 : _b$height,
      _b$margin = _b.margin,
      margin = _b$margin === void 0 ? {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  } : _b$margin,
      _b$reverse = _b.reverse,
      reverse = _b$reverse === void 0 ? false : _b$reverse,
      className = _b.className,
      props = __objRest(_b, ["colors", "points", "width", "height", "margin", "reverse", "className"]);

  var canvasRef = useRef(null);
  var colors2 = useMemo(function () {
    return getColors(schemaName, points);
  }, [points, schemaName]);
  useEffect(function () {
    var canvas = canvasRef.current;
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.display = "block";
    var context = canvas.getContext("2d");

    for (var i = 0; i < points; ++i) {
      var j = !!reverse ? points - i - 1 : i;
      context.fillStyle = colors2[j];
      context.fillRect(i, 0, 1, 1);
    }
  }, [width, height, points, colors2, reverse]);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    style: {
      width: width,
      height: height,
      paddingTop: margin.top,
      paddingRight: margin.right,
      paddingBottom: margin.bottom,
      paddingLeft: margin.left
    },
    className: clsx("HypScale-colors", "HypScale-continuous", className)
  }, props), {
    children: /* @__PURE__ */jsx("canvas", {
      width: points,
      height: 1,
      ref: canvasRef
    })
  }));
};

var DiscreteColorScale = function DiscreteColorScale(_ref20) {
  var chunks = _ref20.chunks,
      _ref20$width = _ref20.width,
      width = _ref20$width === void 0 ? 200 : _ref20$width,
      _ref20$height = _ref20.height,
      height = _ref20$height === void 0 ? 12 : _ref20$height,
      _ref20$margin = _ref20.margin,
      margin = _ref20$margin === void 0 ? {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  } : _ref20$margin,
      _ref20$rectProps = _ref20.rectProps,
      rectProps = _ref20$rectProps === void 0 ? {} : _ref20$rectProps,
      _ref20$reverse = _ref20.reverse,
      reverse = _ref20$reverse === void 0 ? false : _ref20$reverse,
      className = _ref20.className;
  var innerWidth = width - (margin.left + margin.right);
  var positionRange = [1, innerWidth - 1];
  var percentToPosition = getPositionScale("linear", [0, 1], positionRange);
  return /* @__PURE__ */jsx("svg", {
    className: clsx("HypScale-colors", "HypScale-discrete", className),
    width: width,
    height: height,
    children: /* @__PURE__ */jsx("g", {
      transform: "translate(".concat(margin.left, " ").concat(margin.top, ")"),
      children: chunks.map(function (c6, i) {
        return /* @__PURE__ */jsx("rect", __spreadValues({
          x: percentToPosition(c6.x),
          y: 0,
          height: height - (margin.bottom + margin.top),
          width: c6.width * innerWidth,
          style: {
            fill: c6.color
          }
        }, rectProps), c6.value);
      })
    })
  });
};

var Colors = function Colors(_c) {
  var _d = _c,
      height = _d.height,
      props = __objRest(_d, ["height"]);

  var _useScaleContext = useScaleContext(),
      colors2 = _useScaleContext.colors,
      type = _useScaleContext.type,
      margin = _useScaleContext.margin,
      width = _useScaleContext.width,
      chunks = _useScaleContext.chunks,
      reverse = _useScaleContext.reverse;

  return isContinuous(type) ? /* @__PURE__ */jsx(ContinuousColorScale, __spreadValues({
    colors: colors2,
    margin: margin,
    width: width,
    height: height,
    reverse: reverse
  }, props)) : /* @__PURE__ */jsx(DiscreteColorScale, __spreadValues({
    chunks: chunks,
    margin: margin,
    height: height,
    width: width,
    reverse: reverse
  }, props));
};

Colors.propTypes = {
  height: PropTypes.number
};
var xhtml = "http://www.w3.org/1999/xhtml";
var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

function namespace(name) {
  var prefix2 = name += "",
      i = prefix2.indexOf(":");
  if (i >= 0 && (prefix2 = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix2) ? {
    space: namespaces[prefix2],
    local: name
  } : name;
}

function creatorInherit(name) {
  return function () {
    var document2 = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document2.documentElement.namespaceURI === xhtml ? document2.createElement(name) : document2.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function () {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

function creator(name) {
  var fullname = namespace(name);
  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
}

function none() {}

function selector(selector2) {
  return selector2 == null ? none : function () {
    return this.querySelector(selector2);
  };
}

function selection_select(select2) {
  if (typeof select2 !== "function") select2 = selector(select2);

  for (var groups = this._groups, m2 = groups.length, subgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group2 = groups[j], n2 = group2.length, subgroup = subgroups[j] = new Array(n2), node, subnode, i = 0; i < n2; ++i) {
      if ((node = group2[i]) && (subnode = select2.call(node, node.__data__, i, group2))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
}

function array(x) {
  return typeof x === "object" && "length" in x ? x : Array.from(x);
}

function empty() {
  return [];
}

function selectorAll(selector2) {
  return selector2 == null ? empty : function () {
    return this.querySelectorAll(selector2);
  };
}

function arrayAll(select2) {
  return function () {
    var group2 = select2.apply(this, arguments);
    return group2 == null ? [] : array(group2);
  };
}

function selection_selectAll(select2) {
  if (typeof select2 === "function") select2 = arrayAll(select2);else select2 = selectorAll(select2);

  for (var groups = this._groups, m2 = groups.length, subgroups = [], parents = [], j = 0; j < m2; ++j) {
    for (var group2 = groups[j], n2 = group2.length, node, i = 0; i < n2; ++i) {
      if (node = group2[i]) {
        subgroups.push(select2.call(node, node.__data__, i, group2));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
}

function matcher(selector2) {
  return function () {
    return this.matches(selector2);
  };
}

function childMatcher(selector2) {
  return function (node) {
    return node.matches(selector2);
  };
}

var find = Array.prototype.find;

function childFind(match) {
  return function () {
    return find.call(this.children, match);
  };
}

function childFirst() {
  return this.firstElementChild;
}

function selection_selectChild(match) {
  return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
}

var filter = Array.prototype.filter;

function children() {
  return this.children;
}

function childrenFilter(match) {
  return function () {
    return filter.call(this.children, match);
  };
}

function selection_selectChildren(match) {
  return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}

function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m2 = groups.length, subgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group2 = groups[j], n2 = group2.length, subgroup = subgroups[j] = [], node, i = 0; i < n2; ++i) {
      if ((node = group2[i]) && match.call(node, node.__data__, i, group2)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
}

function sparse(update2) {
  return new Array(update2.length);
}

function selection_enter() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
}

function EnterNode(parent, datum2) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum2;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function appendChild(child) {
    return this._parent.insertBefore(child, this._next);
  },
  insertBefore: function insertBefore(child, next) {
    return this._parent.insertBefore(child, next);
  },
  querySelector: function querySelector(selector2) {
    return this._parent.querySelector(selector2);
  },
  querySelectorAll: function querySelectorAll(selector2) {
    return this._parent.querySelectorAll(selector2);
  }
};

function constant(x) {
  return function () {
    return x;
  };
}

function bindIndex(parent, group2, enter, update2, exit, data) {
  var i = 0,
      node,
      groupLength = group2.length,
      dataLength = data.length;

  for (; i < dataLength; ++i) {
    if (node = group2[i]) {
      node.__data__ = data[i];
      update2[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  for (; i < groupLength; ++i) {
    if (node = group2[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group2, enter, update2, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = /* @__PURE__ */new Map(),
      groupLength = group2.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  for (i = 0; i < groupLength; ++i) {
    if (node = group2[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group2) + "";

      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }

  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data[i], i, data) + "";

    if (node = nodeByKeyValue.get(keyValue)) {
      update2[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  for (i = 0; i < groupLength; ++i) {
    if ((node = group2[i]) && nodeByKeyValue.get(keyValues[i]) === node) {
      exit[i] = node;
    }
  }
}

function datum(node) {
  return node.__data__;
}

function selection_data(value, key) {
  if (!arguments.length) return Array.from(this, datum);
  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;
  if (typeof value !== "function") value = constant(value);

  for (var m2 = groups.length, update2 = new Array(m2), enter = new Array(m2), exit = new Array(m2), j = 0; j < m2; ++j) {
    var parent = parents[j],
        group2 = groups[j],
        groupLength = group2.length,
        data = array(value.call(parent, parent && parent.__data__, j, parents)),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update2[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);
    bind(parent, group2, enterGroup, updateGroup, exitGroup, data, key);

    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;

        while (!(next = updateGroup[i1]) && ++i1 < dataLength) {
          ;
        }

        previous._next = next || null;
      }
    }
  }

  update2 = new Selection(update2, parents);
  update2._enter = enter;
  update2._exit = exit;
  return update2;
}

function selection_exit() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
}

function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(),
      update2 = this,
      exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update2 = onupdate(update2);
  if (onexit == null) exit.remove();else onexit(exit);
  return enter && update2 ? enter.merge(update2).order() : update2;
}

function selection_merge(selection) {
  if (!(selection instanceof Selection)) throw new Error("invalid merge");

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m2 = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m2; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n2 = group0.length, merge = merges[j] = new Array(n2), node, i = 0; i < n2; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
}

function selection_order() {
  for (var groups = this._groups, j = -1, m2 = groups.length; ++j < m2;) {
    for (var group2 = groups[j], i = group2.length - 1, next = group2[i], node; --i >= 0;) {
      if (node = group2[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
}

function selection_sort(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m2 = groups.length, sortgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group2 = groups[j], n2 = group2.length, sortgroup = sortgroups[j] = new Array(n2), node, i = 0; i < n2; ++i) {
      if (node = group2[i]) {
        sortgroup[i] = node;
      }
    }

    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
}

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}

function selection_nodes() {
  return Array.from(this);
}

function selection_node() {
  for (var groups = this._groups, j = 0, m2 = groups.length; j < m2; ++j) {
    for (var group2 = groups[j], i = 0, n2 = group2.length; i < n2; ++i) {
      var node = group2[i];
      if (node) return node;
    }
  }

  return null;
}

function selection_size() {
  var size = 0;

  var _iterator10 = _createForOfIteratorHelper(this),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var node = _step10.value;
      ++size;
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  return size;
}

function selection_empty() {
  return !this.node();
}

function selection_each(callback) {
  for (var groups = this._groups, j = 0, m2 = groups.length; j < m2; ++j) {
    for (var group2 = groups[j], i = 0, n2 = group2.length, node; i < n2; ++i) {
      if (node = group2[i]) callback.call(node, node.__data__, i, group2);
    }
  }

  return this;
}

function attrRemove(name) {
  return function () {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function () {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function () {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function () {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function () {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function () {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

function selection_attr(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
  }

  return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
}

function defaultView(node) {
  return node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView;
}

function styleRemove(name) {
  return function () {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority2) {
  return function () {
    this.style.setProperty(name, value, priority2);
  };
}

function styleFunction(name, value, priority2) {
  return function () {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);else this.style.setProperty(name, v, priority2);
  };
}

function selection_style(name, value, priority2) {
  return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority2 == null ? "" : priority2)) : styleValue(this.node(), name);
}

function styleValue(node, name) {
  return node.style.getPropertyValue(name) || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function () {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function () {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function () {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];else this[name] = v;
  };
}

function selection_property(name, value) {
  return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
}

function classArray(string2) {
  return string2.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function add(name) {
    var i = this._names.indexOf(name);

    if (i < 0) {
      this._names.push(name);

      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function remove(name) {
    var i = this._names.indexOf(name);

    if (i >= 0) {
      this._names.splice(i, 1);

      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function contains(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node),
      i = -1,
      n2 = names.length;

  while (++i < n2) {
    list.add(names[i]);
  }
}

function classedRemove(node, names) {
  var list = classList(node),
      i = -1,
      n2 = names.length;

  while (++i < n2) {
    list.remove(names[i]);
  }
}

function classedTrue(names) {
  return function () {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function () {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function () {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

function selection_classed(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()),
        i = -1,
        n2 = names.length;

    while (++i < n2) {
      if (!list.contains(names[i])) return false;
    }

    return true;
  }

  return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
}

function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function () {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function () {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

function selection_text(value) {
  return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
}

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function () {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function () {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

function selection_html(value) {
  return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
}

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

function selection_raise() {
  return this.each(raise);
}

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

function selection_lower() {
  return this.each(lower);
}

function selection_append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function () {
    return this.appendChild(create.apply(this, arguments));
  });
}

function constantNull() {
  return null;
}

function selection_insert(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select2 = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function () {
    return this.insertBefore(create.apply(this, arguments), select2.apply(this, arguments) || null);
  });
}

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

function selection_remove() {
  return this.each(remove);
}

function selection_cloneShallow() {
  var clone = this.cloneNode(false),
      parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true),
      parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}

function selection_datum(value) {
  return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

function contextListener(listener) {
  return function (event) {
    listener.call(this, event, this.__data__);
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function (t) {
    var name = "",
        i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {
      type: t,
      name: name
    };
  });
}

function onRemove(typename) {
  return function () {
    var on = this.__on;
    if (!on) return;

    for (var j = 0, i = -1, m2 = on.length, o; j < m2; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }

    if (++i) on.length = i;else delete this.__on;
  };
}

function onAdd(typename, value, options) {
  return function () {
    var on = this.__on,
        o,
        listener = contextListener(value);
    if (on) for (var j = 0, m2 = on.length; j < m2; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
        this.addEventListener(o.type, o.listener = listener, o.options = options);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options);
    o = {
      type: typename.type,
      name: typename.name,
      value: value,
      listener: listener,
      options: options
    };
    if (!on) this.__on = [o];else on.push(o);
  };
}

function selection_on(typename, value, options) {
  var typenames = parseTypenames(typename + ""),
      i,
      n2 = typenames.length,
      t;

  if (arguments.length < 2) {
    var on = this.node().__on;

    if (on) for (var j = 0, m2 = on.length, o; j < m2; ++j) {
      for (i = 0, o = on[j]; i < n2; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;

  for (i = 0; i < n2; ++i) {
    this.each(on(typenames[i], value, options));
  }

  return this;
}

function dispatchEvent(node, type, params) {
  var window2 = defaultView(node),
      event = window2.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window2.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function () {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function () {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

function selection_dispatch(type, params) {
  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
}

function selection_iterator() {
  var groups, j, m2, group2, i, n2, node;
  return _regeneratorRuntime.wrap(function selection_iterator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          groups = this._groups, j = 0, m2 = groups.length;

        case 1:
          if (!(j < m2)) {
            _context.next = 13;
            break;
          }

          group2 = groups[j], i = 0, n2 = group2.length;

        case 3:
          if (!(i < n2)) {
            _context.next = 10;
            break;
          }

          if (!(node = group2[i])) {
            _context.next = 7;
            break;
          }

          _context.next = 7;
          return node;

        case 7:
          ++i;
          _context.next = 3;
          break;

        case 10:
          ++j;
          _context.next = 1;
          break;

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}

var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection_selection() {
  return this;
}

Selection.prototype = _defineProperty({
  constructor: Selection,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch
}, Symbol.iterator, selection_iterator);

function select(selector2) {
  return typeof selector2 === "string" ? new Selection([[document.querySelector(selector2)]], [document.documentElement]) : new Selection([[selector2]], root);
}

var slice = Array.prototype.slice;

function identity(x) {
  return x;
}

var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + x + ",0)";
}

function translateY(y) {
  return "translate(0," + y + ")";
}

function number(scale) {
  return function (d) {
    return +scale(d);
  };
}

function center(scale, offset) {
  offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
  if (scale.round()) offset = Math.round(offset);
  return function (d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat2 = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis2(context) {
    var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues,
        format2 = tickFormat2 == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity : tickFormat2,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + offset,
        range1 = +range[range.length - 1] + offset,
        position = (scale.bandwidth ? center : number)(scale.copy(), offset),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");
    path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
    tick = tick.merge(tickEnter);
    line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
    text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);
      tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function (d) {
        return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
      });
      tickEnter.attr("opacity", epsilon).attr("transform", function (d) {
        var p2 = this.parentNode.__axis;
        return transform((p2 && isFinite(p2 = p2(d)) ? p2 : position(d)) + offset);
      });
    }

    tickExit.remove();
    path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
    tick.attr("opacity", 1).attr("transform", function (d) {
      return transform(position(d) + offset);
    });
    line.attr(x + "2", k * tickSizeInner);
    text.attr(x, k * spacing).text(format2);
    selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
    selection.each(function () {
      this.__axis = position;
    });
  }

  axis2.scale = function (_) {
    return arguments.length ? (scale = _, axis2) : scale;
  };

  axis2.ticks = function () {
    return tickArguments = slice.call(arguments), axis2;
  };

  axis2.tickArguments = function (_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis2) : tickArguments.slice();
  };

  axis2.tickValues = function (_) {
    return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis2) : tickValues && tickValues.slice();
  };

  axis2.tickFormat = function (_) {
    return arguments.length ? (tickFormat2 = _, axis2) : tickFormat2;
  };

  axis2.tickSize = function (_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis2) : tickSizeInner;
  };

  axis2.tickSizeInner = function (_) {
    return arguments.length ? (tickSizeInner = +_, axis2) : tickSizeInner;
  };

  axis2.tickSizeOuter = function (_) {
    return arguments.length ? (tickSizeOuter = +_, axis2) : tickSizeOuter;
  };

  axis2.tickPadding = function (_) {
    return arguments.length ? (tickPadding = +_, axis2) : tickPadding;
  };

  axis2.offset = function (_) {
    return arguments.length ? (offset = +_, axis2) : offset;
  };

  return axis2;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

var ScaleTicks = function ScaleTicks(_e) {
  var _f = _e,
      _f$position = _f.position,
      position = _f$position === void 0 ? "bottom" : _f$position,
      _f$width = _f.width,
      width = _f$width === void 0 ? 200 : _f$width,
      _f$height = _f.height,
      height = _f$height === void 0 ? 24 : _f$height,
      scale = _f.scale,
      ticks2 = _f.ticks,
      tickArguments = _f.tickArguments,
      tickFormat2 = _f.tickFormat,
      tickValues = _f.tickValues,
      tickSize = _f.tickSize,
      tickSizeInner = _f.tickSizeInner,
      tickSizeOuter = _f.tickSizeOuter,
      tickPadding = _f.tickPadding,
      endTicks = _f.endTicks,
      _f$margin = _f.margin,
      margin = _f$margin === void 0 ? {
    left: 0,
    right: 0
  } : _f$margin,
      className = _f.className,
      reverse = _f.reverse,
      props = __objRest(_f, ["position", "width", "height", "scale", "ticks", "tickArguments", "tickFormat", "tickValues", "tickSize", "tickSizeInner", "tickSizeOuter", "tickPadding", "endTicks", "margin", "className", "reverse"]);

  var innerWidth = width - (margin.left + margin.right);
  var scaleRange = !!reverse ? [innerWidth - 1, 1] : [1, innerWidth - 1];
  var innerScale = scale.copy().range(scaleRange);
  var axisCreator = position === "bottom" ? axisBottom(innerScale) : axisTop(innerScale);

  if (tickFormat2) {
    var formatFunc = typeof tickFormat2 === "string" ? format(tickFormat2) : tickFormat2;
    axisCreator = axisCreator.tickFormat(formatFunc);
  }

  if (Number.isFinite(ticks2)) axisCreator = axisCreator.ticks(ticks2);
  if (tickArguments) axisCreator = axisCreator.tickArguments(tickArguments);
  if (tickValues) axisCreator = axisCreator.tickValues(tickValues);
  if (Number.isFinite(tickSize)) axisCreator.tickSize(tickSize);
  if (Number.isFinite(tickSizeInner)) axisCreator.tickSizeInner(tickSizeInner);
  if (Number.isFinite(tickSizeOuter)) axisCreator.tickSizeOuter(tickSizeOuter);
  if (Number.isFinite(tickPadding)) axisCreator.tickPadding(tickPadding);
  var tickOverrides = tickValues || [];
  if (endTicks) axisCreator.tickValues([].concat(_toConsumableArray(scale.domain()), _toConsumableArray(tickOverrides)));

  var axisRef = function axisRef(axis2) {
    axis2 && axisCreator(select(axis2));
  };

  return /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
    className: clsx("HypScale-ticks", className),
    width: width,
    viewBox: [0, 0, width, height]
  }, props), {
    children: /* @__PURE__ */jsx("g", {
      transform: "translate(".concat(margin.left, " ").concat(position === "bottom" ? 1 : height - 1, ")"),
      ref: axisRef
    })
  }));
};

ScaleTicks.propTypes = {
  scale: PropTypes.any,
  position: PropTypes.oneOf(["bottom", "top"]),
  width: PropTypes.number,
  height: PropTypes.number,
  ticks: PropTypes.number,
  tickArguments: PropTypes.array,
  tickFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  tickValues: PropTypes.array,
  tickSize: PropTypes.number,
  tickSizeInner: PropTypes.number,
  tickSizeOuter: PropTypes.number,
  tickPadding: PropTypes.number,
  margin: PropTypes.object,
  className: PropTypes.string,
  reverse: PropTypes.bool
};

function Ticks(props) {
  var _useScaleContext2 = useScaleContext(),
      width = _useScaleContext2.width,
      scale = _useScaleContext2.position,
      margin = _useScaleContext2.margin,
      type = _useScaleContext2.type,
      chunks = _useScaleContext2.chunks,
      thresholds = _useScaleContext2.thresholds,
      reverse = _useScaleContext2.reverse;

  var tickValues;
  if (type === "quantile" || type === "quantize") tickValues = [].concat(_toConsumableArray(chunks.map(function (c6) {
    return scale.invert(c6.x);
  })), [scale.domain()[!!reverse ? 0 : 1]]);
  if (type === "threshold") tickValues = [scale.domain()[0]].concat(_toConsumableArray(thresholds), [scale.domain()[1]]);
  return /* @__PURE__ */jsx(ScaleTicks, __spreadValues({
    width: width,
    scale: scale,
    margin: margin,
    tickValues: tickValues,
    reverse: reverse
  }, props));
}

Ticks.propTypes = ScaleTicks.propTypes;
var updateQueue = makeQueue();

var raf = function raf(fn) {
  return schedule(fn, updateQueue);
};

var writeQueue = makeQueue();

raf.write = function (fn) {
  return schedule(fn, writeQueue);
};

var onStartQueue = makeQueue();

raf.onStart = function (fn) {
  return schedule(fn, onStartQueue);
};

var onFrameQueue = makeQueue();

raf.onFrame = function (fn) {
  return schedule(fn, onFrameQueue);
};

var onFinishQueue = makeQueue();

raf.onFinish = function (fn) {
  return schedule(fn, onFinishQueue);
};

var timeouts = [];

raf.setTimeout = function (handler, ms) {
  var time = raf.now() + ms;

  var cancel = function cancel() {
    var i = timeouts.findIndex(function (t) {
      return t.cancel == cancel;
    });
    if (~i) timeouts.splice(i, 1);
    pendingCount -= ~i ? 1 : 0;
  };

  var timeout = {
    time: time,
    handler: handler,
    cancel: cancel
  };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start();
  return timeout;
};

var findTimeout = function findTimeout(time) {
  return ~(~timeouts.findIndex(function (t) {
    return t.time > time;
  }) || ~timeouts.length);
};

raf.cancel = function (fn) {
  onStartQueue.delete(fn);
  onFrameQueue.delete(fn);
  updateQueue.delete(fn);
  writeQueue.delete(fn);
  onFinishQueue.delete(fn);
};

raf.sync = function (fn) {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};

raf.throttle = function (fn) {
  var lastArgs;

  function queuedFn() {
    try {
      fn.apply(void 0, _toConsumableArray(lastArgs));
    } finally {
      lastArgs = null;
    }
  }

  function throttled() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key4 = 0; _key4 < _len2; _key4++) {
      args[_key4] = arguments[_key4];
    }

    lastArgs = args;
    raf.onStart(queuedFn);
  }

  throttled.handler = fn;

  throttled.cancel = function () {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };

  return throttled;
};

var nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : function () {};

raf.use = function (impl) {
  return nativeRaf = impl;
};

raf.now = typeof performance != "undefined" ? function () {
  return performance.now();
} : Date.now;

raf.batchedUpdates = function (fn) {
  return fn();
};

raf.catch = console.error;
raf.frameLoop = "always";

raf.advance = function () {
  if (raf.frameLoop !== "demand") {
    console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
  } else {
    update();
  }
};

var ts = -1;
var pendingCount = 0;
var sync = false;

function schedule(fn, queue) {
  if (sync) {
    queue.delete(fn);
    fn(0);
  } else {
    queue.add(fn);
    start();
  }
}

function start() {
  if (ts < 0) {
    ts = 0;

    if (raf.frameLoop !== "demand") {
      nativeRaf(loop);
    }
  }
}

function stop() {
  ts = -1;
}

function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}

function update() {
  var prevTs = ts;
  ts = raf.now();
  var count = findTimeout(ts);

  if (count) {
    eachSafely(timeouts.splice(0, count), function (t) {
      return t.handler();
    });
    pendingCount -= count;
  }

  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();

  if (!pendingCount) {
    stop();
  }
}

function makeQueue() {
  var next = /* @__PURE__ */new Set();
  var current = next;
  return {
    add: function add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },
    delete: function _delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },
    flush: function flush(arg) {
      if (current.size) {
        next = /* @__PURE__ */new Set();
        pendingCount -= current.size;
        eachSafely(current, function (fn) {
          return fn(arg) && next.add(fn);
        });
        pendingCount += next.size;
        current = next;
      }
    }
  };
}

function eachSafely(values, each2) {
  values.forEach(function (value) {
    try {
      each2(value);
    } catch (e) {
      raf.catch(e);
    }
  });
}

function noop() {}

var defineHidden = function defineHidden(obj, key, value) {
  return Object.defineProperty(obj, key, {
    value: value,
    writable: true,
    configurable: true
  });
};

var is = {
  arr: Array.isArray,
  obj: function obj(a) {
    return !!a && a.constructor.name === "Object";
  },
  fun: function fun(a) {
    return typeof a === "function";
  },
  str: function str(a) {
    return typeof a === "string";
  },
  num: function num(a) {
    return typeof a === "number";
  },
  und: function und(a) {
    return a === void 0;
  }
};

function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length) return false;

    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }

    return true;
  }

  return a === b;
}

var each = function each(obj, fn) {
  return obj.forEach(fn);
};

function eachProp(obj, fn, ctx2) {
  if (is.arr(obj)) {
    for (var i = 0; i < obj.length; i++) {
      fn.call(ctx2, obj[i], "".concat(i));
    }

    return;
  }

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx2, obj[key], key);
    }
  }
}

var toArray = function toArray(a) {
  return is.und(a) ? [] : is.arr(a) ? a : [a];
};

function flush(queue, iterator) {
  if (queue.size) {
    var items = Array.from(queue);
    queue.clear();
    each(items, iterator);
  }
}

var flushCalls = function flushCalls(queue) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key5 = 1; _key5 < _len3; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  return flush(queue, function (fn) {
    return fn.apply(void 0, args);
  });
};

var isSSR = function isSSR() {
  return typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
};

var createStringInterpolator$1;
var to;
var colors$1 = null;
var skipAnimation = false;
var willAdvance = noop;

var assign = function assign(globals2) {
  if (globals2.to) to = globals2.to;
  if (globals2.now) raf.now = globals2.now;
  if (globals2.colors !== void 0) colors$1 = globals2.colors;
  if (globals2.skipAnimation != null) skipAnimation = globals2.skipAnimation;
  if (globals2.createStringInterpolator) createStringInterpolator$1 = globals2.createStringInterpolator;
  if (globals2.requestAnimationFrame) raf.use(globals2.requestAnimationFrame);
  if (globals2.batchedUpdates) raf.batchedUpdates = globals2.batchedUpdates;
  if (globals2.willAdvance) willAdvance = globals2.willAdvance;
  if (globals2.frameLoop) raf.frameLoop = globals2.frameLoop;
};

var globals = /* @__PURE__ */Object.freeze({
  __proto__: null,

  get createStringInterpolator() {
    return createStringInterpolator$1;
  },

  get to() {
    return to;
  },

  get colors() {
    return colors$1;
  },

  get skipAnimation() {
    return skipAnimation;
  },

  get willAdvance() {
    return willAdvance;
  },

  assign: assign
});
var startQueue = /* @__PURE__ */new Set();
var currentFrame = [];
var prevFrame = [];
var priority = 0;
var frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },

  start: function start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },
  advance: advance,
  sort: function sort(animation) {
    if (priority) {
      raf.onFrame(function () {
        return frameLoop.sort(animation);
      });
    } else {
      var prevIndex = currentFrame.indexOf(animation);

      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },
  clear: function clear() {
    currentFrame = [];
    startQueue.clear();
  }
};

function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}

function startSafely(animation) {
  if (!currentFrame.includes(animation)) startUnsafely(animation);
}

function startUnsafely(animation) {
  currentFrame.splice(findIndex(currentFrame, function (other) {
    return other.priority > animation.priority;
  }), 0, animation);
}

function advance(dt) {
  var nextFrame = prevFrame;

  for (var i = 0; i < currentFrame.length; i++) {
    var animation = currentFrame[i];
    priority = animation.priority;

    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);

      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }

  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}

function findIndex(arr, test) {
  var index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

var colors = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";

function call() {
  for (var _len4 = arguments.length, parts = new Array(_len4), _key6 = 0; _key6 < _len4; _key6++) {
    parts[_key6] = arguments[_key6];
  }

  return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}

var rgb = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp("hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;

function normalizeColor(color2) {
  var match;

  if (typeof color2 === "number") {
    return color2 >>> 0 === color2 && color2 >= 0 && color2 <= 4294967295 ? color2 : null;
  }

  if (match = hex6.exec(color2)) return parseInt(match[1] + "ff", 16) >>> 0;

  if (colors$1 && colors$1[color2] !== void 0) {
    return colors$1[color2];
  }

  if (match = rgb.exec(color2)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 255) >>> 0;
  }

  if (match = rgba.exec(color2)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
  }

  if (match = hex3.exec(color2)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
  }

  if (match = hex8.exec(color2)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color2)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
  }

  if (match = hsl.exec(color2)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 255) >>> 0;
  }

  if (match = hsla.exec(color2)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
  }

  return null;
}

function hue2rgb(p2, q2, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p2 + (q2 - p2) * 6 * t;
  if (t < 1 / 2) return q2;
  if (t < 2 / 3) return p2 + (q2 - p2) * (2 / 3 - t) * 6;
  return p2;
}

function hslToRgb(h, s, l) {
  var q2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p2 = 2 * l - q2;
  var r = hue2rgb(p2, q2, h + 1 / 3);
  var g2 = hue2rgb(p2, q2, h);
  var b = hue2rgb(p2, q2, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g2 * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  var int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  var int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  var int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  var int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  var r = (int32Color & 4278190080) >>> 24;
  var g2 = (int32Color & 16711680) >>> 16;
  var b = (int32Color & 65280) >>> 8;
  var a = (int32Color & 255) / 255;
  return "rgba(".concat(r, ", ").concat(g2, ", ").concat(b, ", ").concat(a, ")");
}

var createInterpolator = function createInterpolator(range, output, extrapolate) {
  if (is.fun(range)) {
    return range;
  }

  if (is.arr(range)) {
    return createInterpolator({
      range: range,
      output: output,
      extrapolate: extrapolate
    });
  }

  if (is.str(range.output[0])) {
    return createStringInterpolator$1(range);
  }

  var config2 = range;
  var outputRange = config2.output;
  var inputRange = config2.range || [0, 1];
  var extrapolateLeft = config2.extrapolateLeft || config2.extrapolate || "extend";
  var extrapolateRight = config2.extrapolateRight || config2.extrapolate || "extend";

  var easing = config2.easing || function (t) {
    return t;
  };

  return function (input) {
    var range2 = findRange(input, inputRange);
    return interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config2.map);
  };
};

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map2) {
  var result = map2 ? map2(input) : input;

  if (result < inputMin) {
    if (extrapolateLeft === "identity") return result;else if (extrapolateLeft === "clamp") result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === "identity") return result;else if (extrapolateRight === "clamp") result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) {
    if (inputRange[i] >= input) break;
  }

  return i - 1;
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

var $get = Symbol.for("FluidValue.get");
var $observers = Symbol.for("FluidValue.observers");

var hasFluidValue = function hasFluidValue(arg) {
  return Boolean(arg && arg[$get]);
};

var getFluidValue = function getFluidValue(arg) {
  return arg && arg[$get] ? arg[$get]() : arg;
};

var getFluidObservers = function getFluidObservers(target) {
  return target[$observers] || null;
};

function callFluidObserver(observer, event) {
  if (observer.eventObserved) {
    observer.eventObserved(event);
  } else {
    observer(event);
  }
}

function callFluidObservers(target, event) {
  var observers = target[$observers];

  if (observers) {
    observers.forEach(function (observer) {
      callFluidObserver(observer, event);
    });
  }
}

var FluidValue = /*#__PURE__*/_createClass(function FluidValue(get) {
  _classCallCheck(this, FluidValue);

  this[$get] = void 0;
  this[$observers] = void 0;

  if (!get && !(get = this.get)) {
    throw Error("Unknown getter");
  }

  setFluidGetter(this, get);
});

var setFluidGetter = function setFluidGetter(target, get) {
  return setHidden(target, $get, get);
};

function addFluidObserver(target, observer) {
  if (target[$get]) {
    var observers = target[$observers];

    if (!observers) {
      setHidden(target, $observers, observers = /* @__PURE__ */new Set());
    }

    if (!observers.has(observer)) {
      observers.add(observer);

      if (target.observerAdded) {
        target.observerAdded(observers.size, observer);
      }
    }
  }

  return observer;
}

function removeFluidObserver(target, observer) {
  var observers = target[$observers];

  if (observers && observers.has(observer)) {
    var count = observers.size - 1;

    if (count) {
      observers.delete(observer);
    } else {
      target[$observers] = null;
    }

    if (target.observerRemoved) {
      target.observerRemoved(count, observer);
    }
  }
}

var setHidden = function setHidden(target, key, value) {
  return Object.defineProperty(target, key, {
    value: value,
    writable: true,
    configurable: true
  });
};

var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var unitRegex = new RegExp("(".concat(numberRegex.source, ")(%|[a-z]+)"), "i");
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

var variableToRgba = function variableToRgba(input) {
  var _parseCSSVariable = parseCSSVariable(input),
      _parseCSSVariable2 = _slicedToArray(_parseCSSVariable, 2),
      token = _parseCSSVariable2[0],
      fallback = _parseCSSVariable2[1];

  if (!token || isSSR()) {
    return input;
  }

  var value = window.getComputedStyle(document.documentElement).getPropertyValue(token);

  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith("--")) {
    var _value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);

    if (_value) {
      return _value;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }

  return input;
};

var parseCSSVariable = function parseCSSVariable(current) {
  var match = cssVariableRegex.exec(current);
  if (!match) return [,];

  var _match = _slicedToArray(match, 3),
      token = _match[1],
      fallback = _match[2];

  return [token, fallback];
};

var namedColorRegex;

var rgbaRound = function rgbaRound(_, p1, p2, p3, p4) {
  return "rgba(".concat(Math.round(p1), ", ").concat(Math.round(p2), ", ").concat(Math.round(p3), ", ").concat(p4, ")");
};

var createStringInterpolator = function createStringInterpolator(config2) {
  if (!namedColorRegex) namedColorRegex = colors$1 ? new RegExp("(".concat(Object.keys(colors$1).join("|"), ")(?!\\w)"), "g") : /^\b$/;
  var output = config2.output.map(function (value) {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  var keyframes = output.map(function (value) {
    return value.match(numberRegex).map(Number);
  });
  var outputRanges = keyframes[0].map(function (_, i) {
    return keyframes.map(function (values) {
      if (!(i in values)) {
        throw Error('The arity of each "output" value must be equal');
      }

      return values[i];
    });
  });
  var interpolators = outputRanges.map(function (output2) {
    return createInterpolator(_extends$2({}, config2, {
      output: output2
    }));
  });
  return function (input) {
    var _output$find;

    var missingUnit = !unitRegex.test(output[0]) && ((_output$find = output.find(function (value) {
      return unitRegex.test(value);
    })) == null ? void 0 : _output$find.replace(numberRegex, ""));
    var i = 0;
    return output[0].replace(numberRegex, function () {
      return "".concat(interpolators[i++](input)).concat(missingUnit || "");
    }).replace(rgbaRegex, rgbaRound);
  };
};

var prefix = "react-spring: ";

var once = function once(fn) {
  var func = fn;
  var called = false;

  if (typeof func != "function") {
    throw new TypeError("".concat(prefix, "once requires a function parameter"));
  }

  return function () {
    if (!called) {
      func.apply(void 0, arguments);
      called = true;
    }
  };
};

var warnInterpolate = once(console.warn);

function deprecateInterpolate() {
  warnInterpolate("".concat(prefix, "The \"interpolate\" function is deprecated in v9 (use \"to\" instead)"));
}

var warnDirectCall = once(console.warn);

function deprecateDirectCall() {
  warnDirectCall("".concat(prefix, "Directly calling start instead of using the api object is deprecated in v9 (use \".start\" instead), this will be removed in later 0.X.0 versions"));
}

function isAnimatedString(value) {
  return is.str(value) && (value[0] == "#" || /\d/.test(value) || !isSSR() && cssVariableRegex.test(value) || value in (colors$1 || {}));
}

var useOnce = function useOnce(effect) {
  return useEffect(effect, emptyDeps);
};

var emptyDeps = [];

function useForceUpdate() {
  var update2 = useState()[1];
  var mounted = useState(makeMountedRef)[0];
  useOnce(mounted.unmount);
  return function () {
    if (mounted.current) {
      update2({});
    }
  };
}

function makeMountedRef() {
  var mounted = {
    current: true,
    unmount: function unmount() {
      return function () {
        mounted.current = false;
      };
    }
  };
  return mounted;
}

function useMemoOne(getResult, inputs) {
  var _useState = useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  }),
      _useState2 = _slicedToArray(_useState, 1),
      initial = _useState2[0];

  var committed = useRef();
  var prevCache = committed.current;
  var cache = prevCache;

  if (cache) {
    var useCache = Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs));

    if (!useCache) {
      cache = {
        inputs: inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }

  useEffect(function () {
    committed.current = cache;

    if (prevCache == initial) {
      initial.inputs = initial.result = void 0;
    }
  }, [cache]);
  return cache.result;
}

function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }

  for (var i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }

  return true;
}

function usePrev(value) {
  var prevRef = useRef();
  useEffect(function () {
    prevRef.current = value;
  });
  return prevRef.current;
}

var useLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;
var $node = Symbol.for("Animated:node");

var isAnimated = function isAnimated(value) {
  return !!value && value[$node] === value;
};

var getAnimated = function getAnimated(owner) {
  return owner && owner[$node];
};

var setAnimated = function setAnimated(owner, node) {
  return defineHidden(owner, $node, node);
};

var getPayload = function getPayload(owner) {
  return owner && owner[$node] && owner[$node].getPayload();
};

var Animated = /*#__PURE__*/function () {
  function Animated() {
    _classCallCheck(this, Animated);

    this.payload = void 0;
    setAnimated(this, this);
  }

  _createClass(Animated, [{
    key: "getPayload",
    value: function getPayload() {
      return this.payload || [];
    }
  }]);

  return Animated;
}();

var AnimatedValue = /*#__PURE__*/function (_Animated) {
  _inherits(AnimatedValue, _Animated);

  var _super2 = _createSuper(AnimatedValue);

  function AnimatedValue(_value) {
    var _this2;

    _classCallCheck(this, AnimatedValue);

    _this2 = _super2.call(this);
    _this2.done = true;
    _this2.elapsedTime = void 0;
    _this2.lastPosition = void 0;
    _this2.lastVelocity = void 0;
    _this2.v0 = void 0;
    _this2.durationProgress = 0;
    _this2._value = _value;

    if (is.num(_this2._value)) {
      _this2.lastPosition = _this2._value;
    }

    return _this2;
  }

  _createClass(AnimatedValue, [{
    key: "getPayload",
    value: function getPayload() {
      return [this];
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this._value;
    }
  }, {
    key: "setValue",
    value: function setValue(value, step) {
      if (is.num(value)) {
        this.lastPosition = value;

        if (step) {
          value = Math.round(value / step) * step;

          if (this.done) {
            this.lastPosition = value;
          }
        }
      }

      if (this._value === value) {
        return false;
      }

      this._value = value;
      return true;
    }
  }, {
    key: "reset",
    value: function reset() {
      var done = this.done;
      this.done = false;

      if (is.num(this._value)) {
        this.elapsedTime = 0;
        this.durationProgress = 0;
        this.lastPosition = this._value;
        if (done) this.lastVelocity = null;
        this.v0 = null;
      }
    }
  }], [{
    key: "create",
    value: function create(value) {
      return new AnimatedValue(value);
    }
  }]);

  return AnimatedValue;
}(Animated);

var AnimatedString = /*#__PURE__*/function (_AnimatedValue) {
  _inherits(AnimatedString, _AnimatedValue);

  var _super3 = _createSuper(AnimatedString);

  function AnimatedString(value) {
    var _this3;

    _classCallCheck(this, AnimatedString);

    _this3 = _super3.call(this, 0);
    _this3._string = null;
    _this3._toString = void 0;
    _this3._toString = createInterpolator({
      output: [value, value]
    });
    return _this3;
  }

  _createClass(AnimatedString, [{
    key: "getValue",
    value: function getValue() {
      var value = this._string;
      return value == null ? this._string = this._toString(this._value) : value;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      if (is.str(value)) {
        if (value == this._string) {
          return false;
        }

        this._string = value;
        this._value = 1;
      } else if (_get(_getPrototypeOf(AnimatedString.prototype), "setValue", this).call(this, value)) {
        this._string = null;
      } else {
        return false;
      }

      return true;
    }
  }, {
    key: "reset",
    value: function reset(goal) {
      if (goal) {
        this._toString = createInterpolator({
          output: [this.getValue(), goal]
        });
      }

      this._value = 0;

      _get(_getPrototypeOf(AnimatedString.prototype), "reset", this).call(this);
    }
  }], [{
    key: "create",
    value: function create(value) {
      return new AnimatedString(value);
    }
  }]);

  return AnimatedString;
}(AnimatedValue);

var TreeContext = {
  dependencies: null
};

var AnimatedObject = /*#__PURE__*/function (_Animated2) {
  _inherits(AnimatedObject, _Animated2);

  var _super4 = _createSuper(AnimatedObject);

  function AnimatedObject(source) {
    var _this4;

    _classCallCheck(this, AnimatedObject);

    _this4 = _super4.call(this);
    _this4.source = source;

    _this4.setValue(source);

    return _this4;
  }

  _createClass(AnimatedObject, [{
    key: "getValue",
    value: function getValue(animated2) {
      var values = {};
      eachProp(this.source, function (source, key) {
        if (isAnimated(source)) {
          values[key] = source.getValue(animated2);
        } else if (hasFluidValue(source)) {
          values[key] = getFluidValue(source);
        } else if (!animated2) {
          values[key] = source;
        }
      });
      return values;
    }
  }, {
    key: "setValue",
    value: function setValue(source) {
      this.source = source;
      this.payload = this._makePayload(source);
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.payload) {
        each(this.payload, function (node) {
          return node.reset();
        });
      }
    }
  }, {
    key: "_makePayload",
    value: function _makePayload(source) {
      if (source) {
        var payload = /* @__PURE__ */new Set();
        eachProp(source, this._addToPayload, payload);
        return Array.from(payload);
      }
    }
  }, {
    key: "_addToPayload",
    value: function _addToPayload(source) {
      var _this5 = this;

      if (TreeContext.dependencies && hasFluidValue(source)) {
        TreeContext.dependencies.add(source);
      }

      var payload = getPayload(source);

      if (payload) {
        each(payload, function (node) {
          return _this5.add(node);
        });
      }
    }
  }]);

  return AnimatedObject;
}(Animated);

var AnimatedArray = /*#__PURE__*/function (_AnimatedObject) {
  _inherits(AnimatedArray, _AnimatedObject);

  var _super5 = _createSuper(AnimatedArray);

  function AnimatedArray(source) {
    _classCallCheck(this, AnimatedArray);

    return _super5.call(this, source);
  }

  _createClass(AnimatedArray, [{
    key: "getValue",
    value: function getValue() {
      return this.source.map(function (node) {
        return node.getValue();
      });
    }
  }, {
    key: "setValue",
    value: function setValue(source) {
      var payload = this.getPayload();

      if (source.length == payload.length) {
        return payload.map(function (node, i) {
          return node.setValue(source[i]);
        }).some(Boolean);
      }

      _get(_getPrototypeOf(AnimatedArray.prototype), "setValue", this).call(this, source.map(makeAnimated));

      return true;
    }
  }], [{
    key: "create",
    value: function create(source) {
      return new AnimatedArray(source);
    }
  }]);

  return AnimatedArray;
}(AnimatedObject);

function makeAnimated(value) {
  var nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}

function getAnimatedType(value) {
  var parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var withAnimated = function withAnimated(Component, host2) {
  var hasInstance = !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
  return forwardRef(function (givenProps, givenRef) {
    var instanceRef = useRef(null);
    var ref = hasInstance && useCallback(function (value) {
      instanceRef.current = updateRef(givenRef, value);
    }, [givenRef]);

    var _getAnimatedState = getAnimatedState(givenProps, host2),
        _getAnimatedState2 = _slicedToArray(_getAnimatedState, 2),
        props = _getAnimatedState2[0],
        deps = _getAnimatedState2[1];

    var forceUpdate = useForceUpdate();

    var callback = function callback() {
      var instance = instanceRef.current;

      if (hasInstance && !instance) {
        return;
      }

      var didUpdate = instance ? host2.applyAnimatedValues(instance, props.getValue(true)) : false;

      if (didUpdate === false) {
        forceUpdate();
      }
    };

    var observer = new PropsObserver(callback, deps);
    var observerRef = useRef();
    useLayoutEffect(function () {
      var lastObserver = observerRef.current;
      observerRef.current = observer;
      each(deps, function (dep) {
        return addFluidObserver(dep, observer);
      });

      if (lastObserver) {
        each(lastObserver.deps, function (dep) {
          return removeFluidObserver(dep, lastObserver);
        });
        raf.cancel(lastObserver.update);
      }
    });
    useEffect(callback, []);
    useOnce(function () {
      return function () {
        var observer2 = observerRef.current;
        each(observer2.deps, function (dep) {
          return removeFluidObserver(dep, observer2);
        });
      };
    });
    var usedProps = host2.getComponentProps(props.getValue());
    return React.createElement(Component, _extends$1({}, usedProps, {
      ref: ref
    }));
  });
};

var PropsObserver = /*#__PURE__*/function () {
  function PropsObserver(update2, deps) {
    _classCallCheck(this, PropsObserver);

    this.update = update2;
    this.deps = deps;
  }

  _createClass(PropsObserver, [{
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        raf.write(this.update);
      }
    }
  }]);

  return PropsObserver;
}();

function getAnimatedState(props, host2) {
  var dependencies = /* @__PURE__ */new Set();
  TreeContext.dependencies = dependencies;
  if (props.style) props = _extends$1({}, props, {
    style: host2.createAnimatedStyle(props.style)
  });
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}

function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref)) ref(value);else ref.current = value;
  }

  return value;
}

var cacheKey = Symbol.for("AnimatedComponent");

var createHost = function createHost(components) {
  var _ref21 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref21$applyAnimatedV = _ref21.applyAnimatedValues,
      _applyAnimatedValues = _ref21$applyAnimatedV === void 0 ? function () {
    return false;
  } : _ref21$applyAnimatedV,
      _ref21$createAnimated = _ref21.createAnimatedStyle,
      _createAnimatedStyle = _ref21$createAnimated === void 0 ? function (style) {
    return new AnimatedObject(style);
  } : _ref21$createAnimated,
      _ref21$getComponentPr = _ref21.getComponentProps,
      _getComponentProps = _ref21$getComponentPr === void 0 ? function (props) {
    return props;
  } : _ref21$getComponentPr;

  var hostConfig = {
    applyAnimatedValues: _applyAnimatedValues,
    createAnimatedStyle: _createAnimatedStyle,
    getComponentProps: _getComponentProps
  };

  var animated2 = function animated2(Component) {
    var displayName = getDisplayName(Component) || "Anonymous";

    if (is.str(Component)) {
      Component = animated2[Component] || (animated2[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }

    Component.displayName = "Animated(".concat(displayName, ")");
    return Component;
  };

  eachProp(components, function (Component, key) {
    if (is.arr(components)) {
      key = getDisplayName(Component);
    }

    animated2[key] = animated2(Component);
  });
  return {
    animated: animated2
  };
};

var getDisplayName = function getDisplayName(arg) {
  return is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function callProp(value) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key7 = 1; _key7 < _len5; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  return is.fun(value) ? value.apply(void 0, args) : value;
}

var matchProp = function matchProp(value, key) {
  return value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));
};

var resolveProp = function resolveProp(prop, key) {
  return is.obj(prop) ? key && prop[key] : prop;
};

var getDefaultProp = function getDefaultProp(props, key) {
  return props.default === true ? props[key] : props.default ? props.default[key] : void 0;
};

var noopTransform = function noopTransform(value) {
  return value;
};

var getDefaultProps = function getDefaultProps(props) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noopTransform;
  var keys = DEFAULT_PROPS;

  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }

  var defaults2 = {};

  var _iterator11 = _createForOfIteratorHelper(keys),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var key = _step11.value;
      var value = transform(props[key], key);

      if (!is.und(value)) {
        defaults2[key] = value;
      }
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return defaults2;
};

var DEFAULT_PROPS = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"];
var RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  keys: 1,
  callId: 1,
  parentId: 1
};

function getForwardProps(props) {
  var forward = {};
  var count = 0;
  eachProp(props, function (value, prop) {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });

  if (count) {
    return forward;
  }
}

function inferTo(props) {
  var to2 = getForwardProps(props);

  if (to2) {
    var out = {
      to: to2
    };
    eachProp(props, function (val, key) {
      return key in to2 || (out[key] = val);
    });
    return out;
  }

  return _extends({}, props);
}

function computeGoal(value) {
  value = getFluidValue(value);
  return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}

function hasProps(props) {
  for (var _ in props) {
    return true;
  }

  return false;
}

function isAsyncTo(to2) {
  return is.fun(to2) || is.arr(to2) && is.obj(to2[0]);
}

function detachRefs(ctrl, ref) {
  var _ctrl$ref;

  (_ctrl$ref = ctrl.ref) == null ? void 0 : _ctrl$ref.delete(ctrl);
  ref == null ? void 0 : ref.delete(ctrl);
}

function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    var _ctrl$ref2;

    (_ctrl$ref2 = ctrl.ref) == null ? void 0 : _ctrl$ref2.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

var config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};
var c1 = 1.70158;
var c2 = c1 * 1.525;
var c3 = c1 + 1;
var c4 = 2 * Math.PI / 3;
var c5 = 2 * Math.PI / 4.5;

var bounceOut = function bounceOut(x) {
  var n1 = 7.5625;
  var d1 = 2.75;

  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
};

var easings = {
  linear: function linear(x) {
    return x;
  },
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  easeOutQuad: function easeOutQuad(x) {
    return 1 - (1 - x) * (1 - x);
  },
  easeInOutQuad: function easeInOutQuad(x) {
    return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
  },
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  easeOutCubic: function easeOutCubic(x) {
    return 1 - Math.pow(1 - x, 3);
  },
  easeInOutCubic: function easeInOutCubic(x) {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  },
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  easeOutQuart: function easeOutQuart(x) {
    return 1 - Math.pow(1 - x, 4);
  },
  easeInOutQuart: function easeInOutQuart(x) {
    return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
  },
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  easeOutQuint: function easeOutQuint(x) {
    return 1 - Math.pow(1 - x, 5);
  },
  easeInOutQuint: function easeInOutQuint(x) {
    return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
  },
  easeInSine: function easeInSine(x) {
    return 1 - Math.cos(x * Math.PI / 2);
  },
  easeOutSine: function easeOutSine(x) {
    return Math.sin(x * Math.PI / 2);
  },
  easeInOutSine: function easeInOutSine(x) {
    return -(Math.cos(Math.PI * x) - 1) / 2;
  },
  easeInExpo: function easeInExpo(x) {
    return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
  },
  easeOutExpo: function easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  },
  easeInOutExpo: function easeInOutExpo(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2;
  },
  easeInCirc: function easeInCirc(x) {
    return 1 - Math.sqrt(1 - Math.pow(x, 2));
  },
  easeOutCirc: function easeOutCirc(x) {
    return Math.sqrt(1 - Math.pow(x - 1, 2));
  },
  easeInOutCirc: function easeInOutCirc(x) {
    return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
  },
  easeInBack: function easeInBack(x) {
    return c3 * x * x * x - c1 * x * x;
  },
  easeOutBack: function easeOutBack(x) {
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
  },
  easeInOutBack: function easeInOutBack(x) {
    return x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
  },
  easeInElastic: function easeInElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4);
  },
  easeOutElastic: function easeOutElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
  },
  easeInOutElastic: function easeInOutElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1;
  },
  easeInBounce: function easeInBounce(x) {
    return 1 - bounceOut(1 - x);
  },
  easeOutBounce: bounceOut,
  easeInOutBounce: function easeInOutBounce(x) {
    return x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2;
  }
};

var defaults = _extends({}, config.default, {
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
});

var AnimationConfig = /*#__PURE__*/_createClass(function AnimationConfig() {
  _classCallCheck(this, AnimationConfig);

  this.tension = void 0;
  this.friction = void 0;
  this.frequency = void 0;
  this.damping = void 0;
  this.mass = void 0;
  this.velocity = 0;
  this.restVelocity = void 0;
  this.precision = void 0;
  this.progress = void 0;
  this.duration = void 0;
  this.easing = void 0;
  this.clamp = void 0;
  this.bounce = void 0;
  this.decay = void 0;
  this.round = void 0;
  Object.assign(this, defaults);
});

function mergeConfig(config2, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = _extends({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = _extends({}, defaultConfig, newConfig);
  }

  sanitizeConfig(config2, newConfig);
  Object.assign(config2, newConfig);

  for (var key in defaults) {
    if (config2[key] == null) {
      config2[key] = defaults[key];
    }
  }

  var mass = config2.mass,
      frequency = config2.frequency,
      damping = config2.damping;

  if (!is.und(frequency)) {
    if (frequency < 0.01) frequency = 0.01;
    if (damping < 0) damping = 0;
    config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config2.friction = 4 * Math.PI * damping * mass / frequency;
  }

  return config2;
}

function sanitizeConfig(config2, props) {
  if (!is.und(props.decay)) {
    config2.duration = void 0;
  } else {
    var isTensionConfig = !is.und(props.tension) || !is.und(props.friction);

    if (isTensionConfig || !is.und(props.frequency) || !is.und(props.damping) || !is.und(props.mass)) {
      config2.duration = void 0;
      config2.decay = void 0;
    }

    if (isTensionConfig) {
      config2.frequency = void 0;
    }
  }
}

var emptyArray = [];

var Animation = /*#__PURE__*/_createClass(function Animation() {
  _classCallCheck(this, Animation);

  this.changed = false;
  this.values = emptyArray;
  this.toValues = null;
  this.fromValues = emptyArray;
  this.to = void 0;
  this.from = void 0;
  this.config = new AnimationConfig();
  this.immediate = false;
});

function scheduleProps(callId, _ref22) {
  var key = _ref22.key,
      props = _ref22.props,
      defaultProps = _ref22.defaultProps,
      state = _ref22.state,
      actions = _ref22.actions;
  return new Promise(function (resolve, reject) {
    var _props$cancel;

    var delay;
    var timeout;
    var cancel = matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);

    if (cancel) {
      onStart();
    } else {
      if (!is.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }

      var pause = defaultProps == null ? void 0 : defaultProps.pause;

      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }

      delay = callProp(props.delay || 0, key);

      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }

    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }

    function onResume() {
      if (delay > 0 && !globals.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }

    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }

      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);

      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }

      try {
        actions.start(_extends({}, props, {
          callId: callId,
          cancel: cancel
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

var getCombinedResult = function getCombinedResult(target, results) {
  return results.length == 1 ? results[0] : results.some(function (result) {
    return result.cancelled;
  }) ? getCancelledResult(target.get()) : results.every(function (result) {
    return result.noop;
  }) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(function (result) {
    return result.finished;
  }));
};

var getNoopResult = function getNoopResult(value) {
  return {
    value: value,
    noop: true,
    finished: true,
    cancelled: false
  };
};

var getFinishedResult = function getFinishedResult(value, finished) {
  var cancelled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    value: value,
    finished: finished,
    cancelled: cancelled
  };
};

var getCancelledResult = function getCancelledResult(value) {
  return {
    value: value,
    cancelled: true,
    finished: false
  };
};

function runAsync(to2, props, state, target) {
  var callId = props.callId,
      parentId = props.parentId,
      onRest = props.onRest;
  var prevTo = state.asyncTo,
      prevPromise = state.promise;

  if (!parentId && to2 === prevTo && !props.reset) {
    return prevPromise;
  }

  return state.promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var defaultProps, preventBail, bail, bailPromise, bailIfEnded, animate, result, animating;
    return _regeneratorRuntime.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            state.asyncId = callId;
            state.asyncTo = to2;
            defaultProps = getDefaultProps(props, function (value, key) {
              return key === "onRest" ? void 0 : value;
            });
            bailPromise = new Promise(function (resolve, reject) {
              return preventBail = resolve, bail = reject;
            });

            bailIfEnded = function bailIfEnded(bailSignal) {
              var bailResult = callId <= (state.cancelId || 0) && getCancelledResult(target) || callId !== state.asyncId && getFinishedResult(target, false);

              if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
              }
            };

            animate = function animate(arg1, arg2) {
              var bailSignal = new BailSignal();
              var skipAnimationSignal = new SkipAniamtionSignal();
              return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var props2, result2;
                return _regeneratorRuntime.wrap(function _callee$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!globals.skipAnimation) {
                          _context2.next = 5;
                          break;
                        }

                        stopAsync(state);
                        skipAnimationSignal.result = getFinishedResult(target, false);
                        bail(skipAnimationSignal);
                        throw skipAnimationSignal;

                      case 5:
                        bailIfEnded(bailSignal);
                        props2 = is.obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, {
                          to: arg1
                        });
                        props2.parentId = callId;
                        eachProp(defaultProps, function (value, key) {
                          if (is.und(props2[key])) {
                            props2[key] = value;
                          }
                        });
                        _context2.next = 11;
                        return target.start(props2);

                      case 11:
                        result2 = _context2.sent;
                        bailIfEnded(bailSignal);

                        if (!state.paused) {
                          _context2.next = 16;
                          break;
                        }

                        _context2.next = 16;
                        return new Promise(function (resume) {
                          state.resumeQueue.add(resume);
                        });

                      case 16:
                        return _context2.abrupt("return", result2);

                      case 17:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee);
              }))();
            };

            if (!globals.skipAnimation) {
              _context4.next = 9;
              break;
            }

            stopAsync(state);
            return _context4.abrupt("return", getFinishedResult(target, false));

          case 9:
            _context4.prev = 9;

            if (is.arr(to2)) {
              animating = function () {
                var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(queue) {
                  var _iterator12, _step12, props2;

                  return _regeneratorRuntime.wrap(function _callee2$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _iterator12 = _createForOfIteratorHelper(queue);
                          _context3.prev = 1;

                          _iterator12.s();

                        case 3:
                          if ((_step12 = _iterator12.n()).done) {
                            _context3.next = 9;
                            break;
                          }

                          props2 = _step12.value;
                          _context3.next = 7;
                          return animate(props2);

                        case 7:
                          _context3.next = 3;
                          break;

                        case 9:
                          _context3.next = 14;
                          break;

                        case 11:
                          _context3.prev = 11;
                          _context3.t0 = _context3["catch"](1);

                          _iterator12.e(_context3.t0);

                        case 14:
                          _context3.prev = 14;

                          _iterator12.f();

                          return _context3.finish(14);

                        case 17:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee2, null, [[1, 11, 14, 17]]);
                }));

                return function (_x2) {
                  return _ref25.apply(this, arguments);
                };
              }()(to2);
            } else {
              animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            }

            _context4.next = 13;
            return Promise.all([animating.then(preventBail), bailPromise]);

          case 13:
            result = getFinishedResult(target.get(), true, false);
            _context4.next = 27;
            break;

          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](9);

            if (!(_context4.t0 instanceof BailSignal)) {
              _context4.next = 22;
              break;
            }

            result = _context4.t0.result;
            _context4.next = 27;
            break;

          case 22:
            if (!(_context4.t0 instanceof SkipAniamtionSignal)) {
              _context4.next = 26;
              break;
            }

            result = _context4.t0.result;
            _context4.next = 27;
            break;

          case 26:
            throw _context4.t0;

          case 27:
            _context4.prev = 27;

            if (callId == state.asyncId) {
              state.asyncId = parentId;
              state.asyncTo = parentId ? prevTo : void 0;
              state.promise = parentId ? prevPromise : void 0;
            }

            return _context4.finish(27);

          case 30:
            if (is.fun(onRest)) {
              raf.batchedUpdates(function () {
                onRest(result, target, target.item);
              });
            }

            return _context4.abrupt("return", result);

          case 32:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3, null, [[9, 16, 27, 30]]);
  }))();
}

function stopAsync(state, cancelId) {
  flush(state.timeouts, function (t) {
    return t.cancel();
  });
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = void 0;
  if (cancelId) state.cancelId = cancelId;
}

var BailSignal = /*#__PURE__*/function (_Error) {
  _inherits(BailSignal, _Error);

  var _super6 = _createSuper(BailSignal);

  function BailSignal() {
    var _this6;

    _classCallCheck(this, BailSignal);

    _this6 = _super6.call(this, "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    _this6.result = void 0;
    return _this6;
  }

  return _createClass(BailSignal);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SkipAniamtionSignal = /*#__PURE__*/function (_Error2) {
  _inherits(SkipAniamtionSignal, _Error2);

  var _super7 = _createSuper(SkipAniamtionSignal);

  function SkipAniamtionSignal() {
    var _this7;

    _classCallCheck(this, SkipAniamtionSignal);

    _this7 = _super7.call(this, "SkipAnimationSignal");
    _this7.result = void 0;
    return _this7;
  }

  return _createClass(SkipAniamtionSignal);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var isFrameValue = function isFrameValue(value) {
  return value instanceof FrameValue;
};

var nextId$1 = 1;

var FrameValue = /*#__PURE__*/function (_FluidValue) {
  _inherits(FrameValue, _FluidValue);

  var _super8 = _createSuper(FrameValue);

  function FrameValue() {
    var _this8;

    _classCallCheck(this, FrameValue);

    for (var _len6 = arguments.length, args = new Array(_len6), _key8 = 0; _key8 < _len6; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this8 = _super8.call.apply(_super8, [this].concat(args));
    _this8.id = nextId$1++;
    _this8.key = void 0;
    _this8._priority = 0;
    return _this8;
  }

  _createClass(FrameValue, [{
    key: "priority",
    get: function get() {
      return this._priority;
    },
    set: function set(priority2) {
      if (this._priority != priority2) {
        this._priority = priority2;

        this._onPriorityChange(priority2);
      }
    }
  }, {
    key: "get",
    value: function get() {
      var node = getAnimated(this);
      return node && node.getValue();
    }
  }, {
    key: "to",
    value: function to() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key9 = 0; _key9 < _len7; _key9++) {
        args[_key9] = arguments[_key9];
      }

      return globals.to(this, args);
    }
  }, {
    key: "interpolate",
    value: function interpolate() {
      deprecateInterpolate();

      for (var _len8 = arguments.length, args = new Array(_len8), _key10 = 0; _key10 < _len8; _key10++) {
        args[_key10] = arguments[_key10];
      }

      return globals.to(this, args);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.get();
    }
  }, {
    key: "observerAdded",
    value: function observerAdded(count) {
      if (count == 1) this._attach();
    }
  }, {
    key: "observerRemoved",
    value: function observerRemoved(count) {
      if (count == 0) this._detach();
    }
  }, {
    key: "_attach",
    value: function _attach() {}
  }, {
    key: "_detach",
    value: function _detach() {}
  }, {
    key: "_onChange",
    value: function _onChange(value) {
      var idle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      callFluidObservers(this, {
        type: "change",
        parent: this,
        value: value,
        idle: idle
      });
    }
  }, {
    key: "_onPriorityChange",
    value: function _onPriorityChange(priority2) {
      if (!this.idle) {
        frameLoop.sort(this);
      }

      callFluidObservers(this, {
        type: "priority",
        parent: this,
        priority: priority2
      });
    }
  }]);

  return FrameValue;
}(FluidValue);

var $P = Symbol.for("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;

var hasAnimated = function hasAnimated(target) {
  return (target[$P] & HAS_ANIMATED) > 0;
};

var isAnimating = function isAnimating(target) {
  return (target[$P] & IS_ANIMATING) > 0;
};

var isPaused = function isPaused(target) {
  return (target[$P] & IS_PAUSED) > 0;
};

var setActiveBit = function setActiveBit(target, active) {
  return active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
};

var setPausedBit = function setPausedBit(target, paused) {
  return paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;
};

var SpringValue = /*#__PURE__*/function (_FrameValue) {
  _inherits(SpringValue, _FrameValue);

  var _super9 = _createSuper(SpringValue);

  function SpringValue(arg1, arg2) {
    var _this9;

    _classCallCheck(this, SpringValue);

    _this9 = _super9.call(this);
    _this9.key = void 0;
    _this9.animation = new Animation();
    _this9.queue = void 0;
    _this9.defaultProps = {};
    _this9._state = {
      paused: false,
      delayed: false,
      pauseQueue: /* @__PURE__ */new Set(),
      resumeQueue: /* @__PURE__ */new Set(),
      timeouts: /* @__PURE__ */new Set()
    };
    _this9._pendingCalls = /* @__PURE__ */new Set();
    _this9._lastCallId = 0;
    _this9._lastToId = 0;
    _this9._memoizedDuration = 0;

    if (!is.und(arg1) || !is.und(arg2)) {
      var props = is.obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, {
        from: arg1
      });

      if (is.und(props.default)) {
        props.default = true;
      }

      _this9.start(props);
    }

    return _this9;
  }

  _createClass(SpringValue, [{
    key: "idle",
    get: function get() {
      return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
    }
  }, {
    key: "goal",
    get: function get() {
      return getFluidValue(this.animation.to);
    }
  }, {
    key: "velocity",
    get: function get() {
      var node = getAnimated(this);
      return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map(function (node2) {
        return node2.lastVelocity || 0;
      });
    }
  }, {
    key: "hasAnimated",
    get: function get() {
      return hasAnimated(this);
    }
  }, {
    key: "isAnimating",
    get: function get() {
      return isAnimating(this);
    }
  }, {
    key: "isPaused",
    get: function get() {
      return isPaused(this);
    }
  }, {
    key: "isDelayed",
    get: function get() {
      return this._state.delayed;
    }
  }, {
    key: "advance",
    value: function advance(dt) {
      var _this10 = this;

      var idle = true;
      var changed = false;
      var anim = this.animation;
      var config2 = anim.config,
          toValues = anim.toValues;
      var payload = getPayload(anim.to);

      if (!payload && hasFluidValue(anim.to)) {
        toValues = toArray(getFluidValue(anim.to));
      }

      anim.values.forEach(function (node2, i) {
        if (node2.done) return;
        var to2 = node2.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
        var finished = anim.immediate;
        var position = to2;

        if (!finished) {
          position = node2.lastPosition;

          if (config2.tension <= 0) {
            node2.done = true;
            return;
          }

          var elapsed = node2.elapsedTime += dt;
          var from = anim.fromValues[i];
          var v0 = node2.v0 != null ? node2.v0 : node2.v0 = is.arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
          var velocity;

          if (!is.und(config2.duration)) {
            var p2 = 1;

            if (config2.duration > 0) {
              if (_this10._memoizedDuration !== config2.duration) {
                _this10._memoizedDuration = config2.duration;

                if (node2.durationProgress > 0) {
                  node2.elapsedTime = config2.duration * node2.durationProgress;
                  elapsed = node2.elapsedTime += dt;
                }
              }

              p2 = (config2.progress || 0) + elapsed / _this10._memoizedDuration;
              p2 = p2 > 1 ? 1 : p2 < 0 ? 0 : p2;
              node2.durationProgress = p2;
            }

            position = from + config2.easing(p2) * (to2 - from);
            velocity = (position - node2.lastPosition) / dt;
            finished = p2 == 1;
          } else if (config2.decay) {
            var decay = config2.decay === true ? 0.998 : config2.decay;
            var e = Math.exp(-(1 - decay) * elapsed);
            position = from + v0 / (1 - decay) * (1 - e);
            finished = Math.abs(node2.lastPosition - position) < 0.1;
            velocity = v0 * e;
          } else {
            velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
            var precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
            var restVelocity = config2.restVelocity || precision / 10;
            var bounceFactor = config2.clamp ? 0 : config2.bounce;
            var canBounce = !is.und(bounceFactor);
            var isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
            var isMoving;
            var isBouncing = false;
            var step = 1;
            var numSteps = Math.ceil(dt / step);

            for (var n2 = 0; n2 < numSteps; ++n2) {
              isMoving = Math.abs(velocity) > restVelocity;

              if (!isMoving) {
                finished = Math.abs(to2 - position) <= precision;

                if (finished) {
                  break;
                }
              }

              if (canBounce) {
                isBouncing = position == to2 || position > to2 == isGrowing;

                if (isBouncing) {
                  velocity = -velocity * bounceFactor;
                  position = to2;
                }
              }

              var springForce = -config2.tension * 1e-6 * (position - to2);
              var dampingForce = -config2.friction * 1e-3 * velocity;
              var acceleration = (springForce + dampingForce) / config2.mass;
              velocity = velocity + acceleration * step;
              position = position + velocity * step;
            }
          }

          node2.lastVelocity = velocity;

          if (Number.isNaN(position)) {
            console.warn("Got NaN while animating:", _this10);
            finished = true;
          }
        }

        if (payload && !payload[i].done) {
          finished = false;
        }

        if (finished) {
          node2.done = true;
        } else {
          idle = false;
        }

        if (node2.setValue(position, config2.round)) {
          changed = true;
        }
      });
      var node = getAnimated(this);
      var currVal = node.getValue();

      if (idle) {
        var finalVal = getFluidValue(anim.to);

        if ((currVal !== finalVal || changed) && !config2.decay) {
          node.setValue(finalVal);

          this._onChange(finalVal);
        } else if (changed && config2.decay) {
          this._onChange(currVal);
        }

        this._stop();
      } else if (changed) {
        this._onChange(currVal);
      }
    }
  }, {
    key: "set",
    value: function set(value) {
      var _this11 = this;

      raf.batchedUpdates(function () {
        _this11._stop();

        _this11._focus(value);

        _this11._set(value);
      });
      return this;
    }
  }, {
    key: "pause",
    value: function pause() {
      this._update({
        pause: true
      });
    }
  }, {
    key: "resume",
    value: function resume() {
      this._update({
        pause: false
      });
    }
  }, {
    key: "finish",
    value: function finish() {
      var _this12 = this;

      if (isAnimating(this)) {
        var _this$animation = this.animation,
            to2 = _this$animation.to,
            config2 = _this$animation.config;
        raf.batchedUpdates(function () {
          _this12._onStart();

          if (!config2.decay) {
            _this12._set(to2, false);
          }

          _this12._stop();
        });
      }

      return this;
    }
  }, {
    key: "update",
    value: function update(props) {
      var queue = this.queue || (this.queue = []);
      queue.push(props);
      return this;
    }
  }, {
    key: "start",
    value: function start(to2, arg2) {
      var _this13 = this;

      var queue;

      if (!is.und(to2)) {
        queue = [is.obj(to2) ? to2 : _extends({}, arg2, {
          to: to2
        })];
      } else {
        queue = this.queue || [];
        this.queue = [];
      }

      return Promise.all(queue.map(function (props) {
        var up = _this13._update(props);

        return up;
      })).then(function (results) {
        return getCombinedResult(_this13, results);
      });
    }
  }, {
    key: "stop",
    value: function stop(cancel) {
      var _this14 = this;

      var to2 = this.animation.to;

      this._focus(this.get());

      stopAsync(this._state, cancel && this._lastCallId);
      raf.batchedUpdates(function () {
        return _this14._stop(to2, cancel);
      });
      return this;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._update({
        reset: true
      });
    }
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        this._start();
      } else if (event.type == "priority") {
        this.priority = event.priority + 1;
      }
    }
  }, {
    key: "_prepareNode",
    value: function _prepareNode(props) {
      var key = this.key || "";
      var to2 = props.to,
          from = props.from;
      to2 = is.obj(to2) ? to2[key] : to2;

      if (to2 == null || isAsyncTo(to2)) {
        to2 = void 0;
      }

      from = is.obj(from) ? from[key] : from;

      if (from == null) {
        from = void 0;
      }

      var range = {
        to: to2,
        from: from
      };

      if (!hasAnimated(this)) {
        if (props.reverse) {
          var _ref26 = [from, to2];
          to2 = _ref26[0];
          from = _ref26[1];
        }

        from = getFluidValue(from);

        if (!is.und(from)) {
          this._set(from);
        } else if (!getAnimated(this)) {
          this._set(to2);
        }
      }

      return range;
    }
  }, {
    key: "_update",
    value: function _update(_ref, isLoop) {
      var _this15 = this;

      var props = _extends({}, _ref);

      var key = this.key,
          defaultProps = this.defaultProps;
      if (props.default) Object.assign(defaultProps, getDefaultProps(props, function (value, prop) {
        return /^on/.test(prop) ? resolveProp(value, key) : value;
      }));
      mergeActiveFn(this, props, "onProps");
      sendEvent(this, "onProps", props, this);

      var range = this._prepareNode(props);

      if (Object.isFrozen(this)) {
        throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
      }

      var state = this._state;
      return scheduleProps(++this._lastCallId, {
        key: key,
        props: props,
        defaultProps: defaultProps,
        state: state,
        actions: {
          pause: function pause() {
            if (!isPaused(_this15)) {
              setPausedBit(_this15, true);
              flushCalls(state.pauseQueue);
              sendEvent(_this15, "onPause", getFinishedResult(_this15, checkFinished(_this15, _this15.animation.to)), _this15);
            }
          },
          resume: function resume() {
            if (isPaused(_this15)) {
              setPausedBit(_this15, false);

              if (isAnimating(_this15)) {
                _this15._resume();
              }

              flushCalls(state.resumeQueue);
              sendEvent(_this15, "onResume", getFinishedResult(_this15, checkFinished(_this15, _this15.animation.to)), _this15);
            }
          },
          start: this._merge.bind(this, range)
        }
      }).then(function (result) {
        if (props.loop && result.finished && !(isLoop && result.noop)) {
          var nextProps = createLoopUpdate(props);

          if (nextProps) {
            return _this15._update(nextProps, true);
          }
        }

        return result;
      });
    }
  }, {
    key: "_merge",
    value: function _merge(range, props, resolve) {
      var _this16 = this;

      if (props.cancel) {
        this.stop(true);
        return resolve(getCancelledResult(this));
      }

      var hasToProp = !is.und(range.to);
      var hasFromProp = !is.und(range.from);

      if (hasToProp || hasFromProp) {
        if (props.callId > this._lastToId) {
          this._lastToId = props.callId;
        } else {
          return resolve(getCancelledResult(this));
        }
      }

      var key = this.key,
          defaultProps = this.defaultProps,
          anim = this.animation;
      var prevTo = anim.to,
          prevFrom = anim.from;
      var _range$to = range.to,
          to2 = _range$to === void 0 ? prevTo : _range$to,
          _range$from = range.from,
          from = _range$from === void 0 ? prevFrom : _range$from;

      if (hasFromProp && !hasToProp && (!props.default || is.und(to2))) {
        to2 = from;
      }

      if (props.reverse) {
        var _ref27 = [from, to2];
        to2 = _ref27[0];
        from = _ref27[1];
      }

      var hasFromChanged = !isEqual(from, prevFrom);

      if (hasFromChanged) {
        anim.from = from;
      }

      from = getFluidValue(from);
      var hasToChanged = !isEqual(to2, prevTo);

      if (hasToChanged) {
        this._focus(to2);
      }

      var hasAsyncTo = isAsyncTo(props.to);
      var config2 = anim.config;
      var decay = config2.decay,
          velocity = config2.velocity;

      if (hasToProp || hasFromProp) {
        config2.velocity = 0;
      }

      if (props.config && !hasAsyncTo) {
        mergeConfig(config2, callProp(props.config, key), props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
      }

      var node = getAnimated(this);

      if (!node || is.und(to2)) {
        return resolve(getFinishedResult(this, true));
      }

      var reset = is.und(props.reset) ? hasFromProp && !props.default : !is.und(from) && matchProp(props.reset, key);
      var value = reset ? from : this.get();
      var goal = computeGoal(to2);
      var isAnimatable = is.num(goal) || is.arr(goal) || isAnimatedString(goal);
      var immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));

      if (hasToChanged) {
        var nodeType = getAnimatedType(to2);

        if (nodeType !== node.constructor) {
          if (immediate) {
            node = this._set(goal);
          } else throw Error("Cannot animate between ".concat(node.constructor.name, " and ").concat(nodeType.name, ", as the \"to\" prop suggests"));
        }
      }

      var goalType = node.constructor;
      var started = hasFluidValue(to2);
      var finished = false;

      if (!started) {
        var hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;

        if (hasToChanged || hasValueChanged) {
          finished = isEqual(computeGoal(value), goal);
          started = !finished;
        }

        if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config2.decay, decay) || !isEqual(config2.velocity, velocity)) {
          started = true;
        }
      }

      if (finished && isAnimating(this)) {
        if (anim.changed && !reset) {
          started = true;
        } else if (!started) {
          this._stop(prevTo);
        }
      }

      if (!hasAsyncTo) {
        if (started || hasFluidValue(prevTo)) {
          anim.values = node.getPayload();
          anim.toValues = hasFluidValue(to2) ? null : goalType == AnimatedString ? [1] : toArray(goal);
        }

        if (anim.immediate != immediate) {
          anim.immediate = immediate;

          if (!immediate && !reset) {
            this._set(prevTo);
          }
        }

        if (started) {
          var onRest = anim.onRest;
          each(ACTIVE_EVENTS, function (type) {
            return mergeActiveFn(_this16, props, type);
          });
          var result = getFinishedResult(this, checkFinished(this, prevTo));
          flushCalls(this._pendingCalls, result);

          this._pendingCalls.add(resolve);

          if (anim.changed) raf.batchedUpdates(function () {
            anim.changed = !reset;
            onRest == null ? void 0 : onRest(result, _this16);

            if (reset) {
              callProp(defaultProps.onRest, result);
            } else {
              anim.onStart == null ? void 0 : anim.onStart(result, _this16);
            }
          });
        }
      }

      if (reset) {
        this._set(value);
      }

      if (hasAsyncTo) {
        resolve(runAsync(props.to, props, this._state, this));
      } else if (started) {
        this._start();
      } else if (isAnimating(this) && !hasToChanged) {
        this._pendingCalls.add(resolve);
      } else {
        resolve(getNoopResult(value));
      }
    }
  }, {
    key: "_focus",
    value: function _focus(value) {
      var anim = this.animation;

      if (value !== anim.to) {
        if (getFluidObservers(this)) {
          this._detach();
        }

        anim.to = value;

        if (getFluidObservers(this)) {
          this._attach();
        }
      }
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var priority2 = 0;
      var to2 = this.animation.to;

      if (hasFluidValue(to2)) {
        addFluidObserver(to2, this);

        if (isFrameValue(to2)) {
          priority2 = to2.priority + 1;
        }
      }

      this.priority = priority2;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      var to2 = this.animation.to;

      if (hasFluidValue(to2)) {
        removeFluidObserver(to2, this);
      }
    }
  }, {
    key: "_set",
    value: function _set(arg) {
      var _this17 = this;

      var idle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var value = getFluidValue(arg);

      if (!is.und(value)) {
        var oldNode = getAnimated(this);

        if (!oldNode || !isEqual(value, oldNode.getValue())) {
          var nodeType = getAnimatedType(value);

          if (!oldNode || oldNode.constructor != nodeType) {
            setAnimated(this, nodeType.create(value));
          } else {
            oldNode.setValue(value);
          }

          if (oldNode) {
            raf.batchedUpdates(function () {
              _this17._onChange(value, idle);
            });
          }
        }
      }

      return getAnimated(this);
    }
  }, {
    key: "_onStart",
    value: function _onStart() {
      var anim = this.animation;

      if (!anim.changed) {
        anim.changed = true;
        sendEvent(this, "onStart", getFinishedResult(this, checkFinished(this, anim.to)), this);
      }
    }
  }, {
    key: "_onChange",
    value: function _onChange(value, idle) {
      if (!idle) {
        this._onStart();

        callProp(this.animation.onChange, value, this);
      }

      callProp(this.defaultProps.onChange, value, this);

      _get(_getPrototypeOf(SpringValue.prototype), "_onChange", this).call(this, value, idle);
    }
  }, {
    key: "_start",
    value: function _start() {
      var anim = this.animation;
      getAnimated(this).reset(getFluidValue(anim.to));

      if (!anim.immediate) {
        anim.fromValues = anim.values.map(function (node) {
          return node.lastPosition;
        });
      }

      if (!isAnimating(this)) {
        setActiveBit(this, true);

        if (!isPaused(this)) {
          this._resume();
        }
      }
    }
  }, {
    key: "_resume",
    value: function _resume() {
      if (globals.skipAnimation) {
        this.finish();
      } else {
        frameLoop.start(this);
      }
    }
  }, {
    key: "_stop",
    value: function _stop(goal, cancel) {
      if (isAnimating(this)) {
        setActiveBit(this, false);
        var anim = this.animation;
        each(anim.values, function (node) {
          node.done = true;
        });

        if (anim.toValues) {
          anim.onChange = anim.onPause = anim.onResume = void 0;
        }

        callFluidObservers(this, {
          type: "idle",
          parent: this
        });
        var result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal != null ? goal : anim.to));
        flushCalls(this._pendingCalls, result);

        if (anim.changed) {
          anim.changed = false;
          sendEvent(this, "onRest", result, this);
        }
      }
    }
  }]);

  return SpringValue;
}(FrameValue);

function checkFinished(target, to2) {
  var goal = computeGoal(to2);
  var value = computeGoal(target.get());
  return isEqual(value, goal);
}

function createLoopUpdate(props) {
  var loop2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.loop;
  var to2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : props.to;
  var loopRet = callProp(loop2);

  if (loopRet) {
    var overrides = loopRet !== true && inferTo(loopRet);
    var reverse = (overrides || props).reverse;
    var reset = !overrides || overrides.reset;
    return createUpdate(_extends({}, props, {
      loop: loop2,
      default: false,
      pause: void 0,
      to: !reverse || isAsyncTo(to2) ? to2 : void 0,
      from: reset ? props.from : void 0,
      reset: reset
    }, overrides));
  }
}

function createUpdate(props) {
  var _props = props = inferTo(props),
      to2 = _props.to,
      from = _props.from;

  var keys = /* @__PURE__ */new Set();
  if (is.obj(to2)) findDefined(to2, keys);
  if (is.obj(from)) findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}

function declareUpdate(props) {
  var update2 = createUpdate(props);

  if (is.und(update2.default)) {
    update2.default = getDefaultProps(update2);
  }

  return update2;
}

function findDefined(values, keys) {
  eachProp(values, function (value, key) {
    return value != null && keys.add(key);
  });
}

var ACTIVE_EVENTS = ["onStart", "onRest", "onChange", "onPause", "onResume"];

function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}

function sendEvent(target, type) {
  var _target$animation$typ2, _target$defaultProps$2;

  var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;

  for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key11 = 2; _key11 < _len9; _key11++) {
    args[_key11 - 2] = arguments[_key11];
  }

  (_target$animation$typ = (_target$animation = target.animation)[type]) == null ? void 0 : (_target$animation$typ2 = _target$animation$typ).call.apply(_target$animation$typ2, [_target$animation].concat(args));
  (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null ? void 0 : (_target$defaultProps$2 = _target$defaultProps$).call.apply(_target$defaultProps$2, [_target$defaultProps].concat(args));
}

var BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
var nextId = 1;

var Controller = /*#__PURE__*/function () {
  function Controller(props, flush2) {
    _classCallCheck(this, Controller);

    this.id = nextId++;
    this.springs = {};
    this.queue = [];
    this.ref = void 0;
    this._flush = void 0;
    this._initialProps = void 0;
    this._lastAsyncId = 0;
    this._active = /* @__PURE__ */new Set();
    this._changed = /* @__PURE__ */new Set();
    this._started = false;
    this._item = void 0;
    this._state = {
      paused: false,
      pauseQueue: /* @__PURE__ */new Set(),
      resumeQueue: /* @__PURE__ */new Set(),
      timeouts: /* @__PURE__ */new Set()
    };
    this._events = {
      onStart: /* @__PURE__ */new Map(),
      onChange: /* @__PURE__ */new Map(),
      onRest: /* @__PURE__ */new Map()
    };
    this._onFrame = this._onFrame.bind(this);

    if (flush2) {
      this._flush = flush2;
    }

    if (props) {
      this.start(_extends({
        default: true
      }, props));
    }
  }

  _createClass(Controller, [{
    key: "idle",
    get: function get() {
      return !this._state.asyncTo && Object.values(this.springs).every(function (spring) {
        return spring.idle && !spring.isDelayed && !spring.isPaused;
      });
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(item) {
      this._item = item;
    }
  }, {
    key: "get",
    value: function get() {
      var values = {};
      this.each(function (spring, key) {
        return values[key] = spring.get();
      });
      return values;
    }
  }, {
    key: "set",
    value: function set(values) {
      for (var key in values) {
        var value = values[key];

        if (!is.und(value)) {
          this.springs[key].set(value);
        }
      }
    }
  }, {
    key: "update",
    value: function update(props) {
      if (props) {
        this.queue.push(createUpdate(props));
      }

      return this;
    }
  }, {
    key: "start",
    value: function start(props) {
      var queue = this.queue;

      if (props) {
        queue = toArray(props).map(createUpdate);
      } else {
        this.queue = [];
      }

      if (this._flush) {
        return this._flush(this, queue);
      }

      prepareKeys(this, queue);
      return flushUpdateQueue(this, queue);
    }
  }, {
    key: "stop",
    value: function stop(arg, keys) {
      if (arg !== !!arg) {
        keys = arg;
      }

      if (keys) {
        var springs = this.springs;
        each(toArray(keys), function (key) {
          return springs[key].stop(!!arg);
        });
      } else {
        stopAsync(this._state, this._lastAsyncId);
        this.each(function (spring) {
          return spring.stop(!!arg);
        });
      }

      return this;
    }
  }, {
    key: "pause",
    value: function pause(keys) {
      if (is.und(keys)) {
        this.start({
          pause: true
        });
      } else {
        var springs = this.springs;
        each(toArray(keys), function (key) {
          return springs[key].pause();
        });
      }

      return this;
    }
  }, {
    key: "resume",
    value: function resume(keys) {
      if (is.und(keys)) {
        this.start({
          pause: false
        });
      } else {
        var springs = this.springs;
        each(toArray(keys), function (key) {
          return springs[key].resume();
        });
      }

      return this;
    }
  }, {
    key: "each",
    value: function each(iterator) {
      eachProp(this.springs, iterator);
    }
  }, {
    key: "_onFrame",
    value: function _onFrame() {
      var _this18 = this;

      var _this$_events = this._events,
          onStart = _this$_events.onStart,
          onChange = _this$_events.onChange,
          onRest = _this$_events.onRest;
      var active = this._active.size > 0;
      var changed = this._changed.size > 0;

      if (active && !this._started || changed && !this._started) {
        this._started = true;
        flush(onStart, function (_ref28) {
          var _ref29 = _slicedToArray(_ref28, 2),
              onStart2 = _ref29[0],
              result = _ref29[1];

          result.value = _this18.get();
          onStart2(result, _this18, _this18._item);
        });
      }

      var idle = !active && this._started;
      var values = changed || idle && onRest.size ? this.get() : null;

      if (changed && onChange.size) {
        flush(onChange, function (_ref30) {
          var _ref31 = _slicedToArray(_ref30, 2),
              onChange2 = _ref31[0],
              result = _ref31[1];

          result.value = values;
          onChange2(result, _this18, _this18._item);
        });
      }

      if (idle) {
        this._started = false;
        flush(onRest, function (_ref32) {
          var _ref33 = _slicedToArray(_ref32, 2),
              onRest2 = _ref33[0],
              result = _ref33[1];

          result.value = values;
          onRest2(result, _this18, _this18._item);
        });
      }
    }
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        this._changed.add(event.parent);

        if (!event.idle) {
          this._active.add(event.parent);
        }
      } else if (event.type == "idle") {
        this._active.delete(event.parent);
      } else return;

      raf.onFrame(this._onFrame);
    }
  }]);

  return Controller;
}();

function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map(function (props) {
    return flushUpdate(ctrl, props);
  })).then(function (results) {
    return getCombinedResult(ctrl, results);
  });
}

function flushUpdate(_x3, _x4, _x5) {
  return _flushUpdate.apply(this, arguments);
}

function _flushUpdate() {
  _flushUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ctrl, props, isLoop) {
    var keys, to2, from, loop2, onRest, onResolve, defaults2, asyncTo, state, promises, cancel, result, nextProps;
    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            keys = props.keys, to2 = props.to, from = props.from, loop2 = props.loop, onRest = props.onRest, onResolve = props.onResolve;
            defaults2 = is.obj(props.default) && props.default;

            if (loop2) {
              props.loop = false;
            }

            if (to2 === false) props.to = null;
            if (from === false) props.from = null;
            asyncTo = is.arr(to2) || is.fun(to2) ? to2 : void 0;

            if (asyncTo) {
              props.to = void 0;
              props.onRest = void 0;

              if (defaults2) {
                defaults2.onRest = void 0;
              }
            } else {
              each(BATCHED_EVENTS, function (key) {
                var handler = props[key];

                if (is.fun(handler)) {
                  var queue = ctrl["_events"][key];

                  props[key] = function (_ref37) {
                    var finished = _ref37.finished,
                        cancelled = _ref37.cancelled;
                    var result2 = queue.get(handler);

                    if (result2) {
                      if (!finished) result2.finished = false;
                      if (cancelled) result2.cancelled = true;
                    } else {
                      queue.set(handler, {
                        value: null,
                        finished: finished || false,
                        cancelled: cancelled || false
                      });
                    }
                  };

                  if (defaults2) {
                    defaults2[key] = props[key];
                  }
                }
              });
            }

            state = ctrl["_state"];

            if (props.pause === !state.paused) {
              state.paused = props.pause;
              flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
            } else if (state.paused) {
              props.pause = true;
            }

            promises = (keys || Object.keys(ctrl.springs)).map(function (key) {
              return ctrl.springs[key].start(props);
            });
            cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;

            if (asyncTo || cancel && state.asyncId) {
              promises.push(scheduleProps(++ctrl["_lastAsyncId"], {
                props: props,
                state: state,
                actions: {
                  pause: noop,
                  resume: noop,
                  start: function start(props2, resolve) {
                    if (cancel) {
                      stopAsync(state, ctrl["_lastAsyncId"]);
                      resolve(getCancelledResult(ctrl));
                    } else {
                      props2.onRest = onRest;
                      resolve(runAsync(asyncTo, props2, state, ctrl));
                    }
                  }
                }
              }));
            }

            if (!state.paused) {
              _context5.next = 15;
              break;
            }

            _context5.next = 15;
            return new Promise(function (resume) {
              state.resumeQueue.add(resume);
            });

          case 15:
            _context5.t0 = getCombinedResult;
            _context5.t1 = ctrl;
            _context5.next = 19;
            return Promise.all(promises);

          case 19:
            _context5.t2 = _context5.sent;
            result = (0, _context5.t0)(_context5.t1, _context5.t2);

            if (!(loop2 && result.finished && !(isLoop && result.noop))) {
              _context5.next = 26;
              break;
            }

            nextProps = createLoopUpdate(props, loop2, to2);

            if (!nextProps) {
              _context5.next = 26;
              break;
            }

            prepareKeys(ctrl, [nextProps]);
            return _context5.abrupt("return", flushUpdate(ctrl, nextProps, true));

          case 26:
            if (onResolve) {
              raf.batchedUpdates(function () {
                return onResolve(result, ctrl, ctrl.item);
              });
            }

            return _context5.abrupt("return", result);

          case 28:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));
  return _flushUpdate.apply(this, arguments);
}

function getSprings(ctrl, props) {
  var springs = _extends({}, ctrl.springs);

  if (props) {
    each(toArray(props), function (props2) {
      if (is.und(props2.keys)) {
        props2 = createUpdate(props2);
      }

      if (!is.obj(props2.to)) {
        props2 = _extends({}, props2, {
          to: void 0
        });
      }

      prepareSprings(springs, props2, function (key) {
        return createSpring(key);
      });
    });
  }

  setSprings(ctrl, springs);
  return springs;
}

function setSprings(ctrl, springs) {
  eachProp(springs, function (spring, key) {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}

function createSpring(key, observer) {
  var spring = new SpringValue();
  spring.key = key;

  if (observer) {
    addFluidObserver(spring, observer);
  }

  return spring;
}

function prepareSprings(springs, props, create) {
  if (props.keys) {
    each(props.keys, function (key) {
      var spring = springs[key] || (springs[key] = create(key));
      spring["_prepareNode"](props);
    });
  }
}

function prepareKeys(ctrl, queue) {
  each(queue, function (props) {
    prepareSprings(ctrl.springs, props, function (key) {
      return createSpring(key, ctrl);
    });
  });
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded$3 = ["children"];

var SpringContext = function SpringContext(_ref) {
  var children2 = _ref.children,
      props = _objectWithoutPropertiesLoose$1(_ref, _excluded$3);

  var inherited = useContext(ctx);
  var pause = props.pause || !!inherited.pause,
      immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(function () {
    return {
      pause: pause,
      immediate: immediate
    };
  }, [pause, immediate]);
  var Provider = ctx.Provider;
  return React.createElement(Provider, {
    value: props
  }, children2);
};

var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;

function makeContext(target, init) {
  Object.assign(target, React.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}

var SpringRef = function SpringRef() {
  var current = [];

  var SpringRef2 = function SpringRef3(props) {
    deprecateDirectCall();
    var results = [];
    each(current, function (ctrl, i) {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        var update2 = _getProps(props, ctrl, i);

        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };

  SpringRef2.current = current;

  SpringRef2.add = function (ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };

  SpringRef2.delete = function (ctrl) {
    var i = current.indexOf(ctrl);
    if (~i) current.splice(i, 1);
  };

  SpringRef2.pause = function () {
    var _arguments = arguments;
    each(current, function (ctrl) {
      return ctrl.pause.apply(ctrl, _toConsumableArray(_arguments));
    });
    return this;
  };

  SpringRef2.resume = function () {
    var _arguments2 = arguments;
    each(current, function (ctrl) {
      return ctrl.resume.apply(ctrl, _toConsumableArray(_arguments2));
    });
    return this;
  };

  SpringRef2.set = function (values) {
    each(current, function (ctrl) {
      return ctrl.set(values);
    });
  };

  SpringRef2.start = function (props) {
    var _this19 = this;

    var results = [];
    each(current, function (ctrl, i) {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        var update2 = _this19._getProps(props, ctrl, i);

        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };

  SpringRef2.stop = function () {
    var _arguments3 = arguments;
    each(current, function (ctrl) {
      return ctrl.stop.apply(ctrl, _toConsumableArray(_arguments3));
    });
    return this;
  };

  SpringRef2.update = function (props) {
    var _this20 = this;

    each(current, function (ctrl, i) {
      return ctrl.update(_this20._getProps(props, ctrl, i));
    });
    return this;
  };

  var _getProps = function _getProps2(arg, ctrl, index) {
    return is.fun(arg) ? arg(index, ctrl) : arg;
  };

  SpringRef2._getProps = _getProps;
  return SpringRef2;
};

function useSprings(length, props, deps) {
  var _arguments4 = arguments;
  var propsFn = is.fun(props) && props;
  if (propsFn && !deps) deps = [];
  var ref = useMemo(function () {
    return propsFn || _arguments4.length == 3 ? SpringRef() : void 0;
  }, []);
  var layoutId = useRef(0);
  var forceUpdate = useForceUpdate();
  var state = useMemo(function () {
    return {
      ctrls: [],
      queue: [],
      flush: function flush(ctrl, updates2) {
        var springs2 = getSprings(ctrl, updates2);
        var canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some(function (key) {
          return !ctrl.springs[key];
        });
        return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise(function (resolve) {
          setSprings(ctrl, springs2);
          state.queue.push(function () {
            resolve(flushUpdateQueue(ctrl, updates2));
          });
          forceUpdate();
        });
      }
    };
  }, []);
  var ctrls = useRef(_toConsumableArray(state.ctrls));
  var updates = [];
  var prevLength = usePrev(length) || 0;
  useMemo(function () {
    each(ctrls.current.slice(length, prevLength), function (ctrl) {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  useMemo(function () {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);

  function declareUpdates(startIndex, endIndex) {
    for (var i = startIndex; i < endIndex; i++) {
      var ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      var update2 = propsFn ? propsFn(i, ctrl) : props[i];

      if (update2) {
        updates[i] = declareUpdate(update2);
      }
    }
  }

  var springs = ctrls.current.map(function (ctrl, i) {
    return getSprings(ctrl, updates[i]);
  });
  var context = useContext(SpringContext);
  var prevContext = usePrev(context);
  var hasContext = context !== prevContext && hasProps(context);
  useLayoutEffect(function () {
    layoutId.current++;
    state.ctrls = ctrls.current;
    var queue = state.queue;

    if (queue.length) {
      state.queue = [];
      each(queue, function (cb) {
        return cb();
      });
    }

    each(ctrls.current, function (ctrl, i) {
      ref == null ? void 0 : ref.add(ctrl);

      if (hasContext) {
        ctrl.start({
          default: context
        });
      }

      var update2 = updates[i];

      if (update2) {
        replaceRef(ctrl, update2.ref);

        if (ctrl.ref) {
          ctrl.queue.push(update2);
        } else {
          ctrl.start(update2);
        }
      }
    });
  });
  useOnce(function () {
    return function () {
      each(state.ctrls, function (ctrl) {
        return ctrl.stop(true);
      });
    };
  });
  var values = springs.map(function (x) {
    return _extends({}, x);
  });
  return ref ? [values, ref] : values;
}

function useSpring(props, deps) {
  var isFn = is.fun(props);

  var _useSprings = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps),
      _useSprings2 = _slicedToArray(_useSprings, 2),
      _useSprings2$ = _slicedToArray(_useSprings2[0], 1),
      values = _useSprings2$[0],
      ref = _useSprings2[1];

  return isFn || arguments.length == 2 ? [values, ref] : values;
}

var TransitionPhase;

(function (TransitionPhase2) {
  TransitionPhase2["MOUNT"] = "mount";
  TransitionPhase2["ENTER"] = "enter";
  TransitionPhase2["UPDATE"] = "update";
  TransitionPhase2["LEAVE"] = "leave";
})(TransitionPhase || (TransitionPhase = {}));

var Interpolation = /*#__PURE__*/function (_FrameValue2) {
  _inherits(Interpolation, _FrameValue2);

  var _super10 = _createSuper(Interpolation);

  function Interpolation(source, args) {
    var _this21;

    _classCallCheck(this, Interpolation);

    _this21 = _super10.call(this);
    _this21.key = void 0;
    _this21.idle = true;
    _this21.calc = void 0;
    _this21._active = /* @__PURE__ */new Set();
    _this21.source = source;
    _this21.calc = createInterpolator.apply(void 0, _toConsumableArray(args));

    var value = _this21._get();

    var nodeType = getAnimatedType(value);
    setAnimated(_assertThisInitialized(_this21), nodeType.create(value));
    return _this21;
  }

  _createClass(Interpolation, [{
    key: "advance",
    value: function advance(_dt) {
      var value = this._get();

      var oldValue = this.get();

      if (!isEqual(value, oldValue)) {
        getAnimated(this).setValue(value);

        this._onChange(value, this.idle);
      }

      if (!this.idle && checkIdle(this._active)) {
        becomeIdle(this);
      }
    }
  }, {
    key: "_get",
    value: function _get() {
      var inputs = is.arr(this.source) ? this.source.map(getFluidValue) : toArray(getFluidValue(this.source));
      return this.calc.apply(this, _toConsumableArray(inputs));
    }
  }, {
    key: "_start",
    value: function _start() {
      var _this22 = this;

      if (this.idle && !checkIdle(this._active)) {
        this.idle = false;
        each(getPayload(this), function (node) {
          node.done = false;
        });

        if (globals.skipAnimation) {
          raf.batchedUpdates(function () {
            return _this22.advance();
          });
          becomeIdle(this);
        } else {
          frameLoop.start(this);
        }
      }
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this23 = this;

      var priority2 = 1;
      each(toArray(this.source), function (source) {
        if (hasFluidValue(source)) {
          addFluidObserver(source, _this23);
        }

        if (isFrameValue(source)) {
          if (!source.idle) {
            _this23._active.add(source);
          }

          priority2 = Math.max(priority2, source.priority + 1);
        }
      });
      this.priority = priority2;

      this._start();
    }
  }, {
    key: "_detach",
    value: function _detach() {
      var _this24 = this;

      each(toArray(this.source), function (source) {
        if (hasFluidValue(source)) {
          removeFluidObserver(source, _this24);
        }
      });

      this._active.clear();

      becomeIdle(this);
    }
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        if (event.idle) {
          this.advance();
        } else {
          this._active.add(event.parent);

          this._start();
        }
      } else if (event.type == "idle") {
        this._active.delete(event.parent);
      } else if (event.type == "priority") {
        this.priority = toArray(this.source).reduce(function (highest, parent) {
          return Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1);
        }, 0);
      }
    }
  }]);

  return Interpolation;
}(FrameValue);

function isIdle(source) {
  return source.idle !== false;
}

function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}

function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    each(getPayload(self), function (node) {
      node.done = true;
    });
    callFluidObservers(self, {
      type: "idle",
      parent: self
    });
  }
}

globals.assign({
  createStringInterpolator: createStringInterpolator,
  to: function to(source, args) {
    return new Interpolation(source, args);
  }
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded$2 = ["style", "children", "scrollTop", "scrollLeft"];
var isCustomPropRE = /^--/;

function dangerousStyleValue(name, value) {
  if (value == null || typeof value === "boolean" || value === "") return "";
  if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px";
  return ("" + value).trim();
}

var attributeCache = {};

function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }

  var isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";

  var _ref = props,
      style = _ref.style,
      children2 = _ref.children,
      scrollTop = _ref.scrollTop,
      scrollLeft = _ref.scrollLeft,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var values = Object.values(attributes);
  var names = Object.keys(attributes).map(function (name) {
    return isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, function (n2) {
      return "-" + n2.toLowerCase();
    }));
  });

  if (children2 !== void 0) {
    instance.textContent = children2;
  }

  for (var name in style) {
    if (style.hasOwnProperty(name)) {
      var value = dangerousStyleValue(name, style[name]);

      if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }

  names.forEach(function (name, i) {
    instance.setAttribute(name, values[i]);
  });

  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }

  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
}

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

var prefixKey = function prefixKey(prefix2, key) {
  return prefix2 + key.charAt(0).toUpperCase() + key.substring(1);
};

var prefixes = ["Webkit", "Ms", "Moz", "O"];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce(function (acc, prop) {
  prefixes.forEach(function (prefix2) {
    return acc[prefixKey(prefix2, prop)] = acc[prop];
  });
  return acc;
}, isUnitlessNumber);
var _excluded$1 = ["x", "y", "z"];
var domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var pxTransforms = /^(translate)/;
var degTransforms = /^(rotate|skew)/;

var addUnit = function addUnit(value, unit2) {
  return is.num(value) && value !== 0 ? value + unit2 : value;
};

var isValueIdentity = function isValueIdentity(value, id) {
  return is.arr(value) ? value.every(function (v) {
    return isValueIdentity(v, id);
  }) : is.num(value) ? value === id : parseFloat(value) === id;
};

var AnimatedStyle = /*#__PURE__*/function (_AnimatedObject2) {
  _inherits(AnimatedStyle, _AnimatedObject2);

  var _super11 = _createSuper(AnimatedStyle);

  function AnimatedStyle(_ref) {
    _classCallCheck(this, AnimatedStyle);

    var x = _ref.x,
        y = _ref.y,
        z = _ref.z,
        style = _objectWithoutPropertiesLoose(_ref, _excluded$1);

    var inputs = [];
    var transforms = [];

    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push(function (xyz) {
        return ["translate3d(".concat(xyz.map(function (v) {
          return addUnit(v, "px");
        }).join(","), ")"), isValueIdentity(xyz, 0)];
      });
    }

    eachProp(style, function (value, key) {
      if (key === "transform") {
        inputs.push([value || ""]);
        transforms.push(function (transform) {
          return [transform, transform === ""];
        });
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (is.und(value)) return;
        var unit2 = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
        inputs.push(toArray(value));
        transforms.push(key === "rotate3d" ? function (_ref34) {
          var _ref35 = _slicedToArray(_ref34, 4),
              x2 = _ref35[0],
              y2 = _ref35[1],
              z2 = _ref35[2],
              deg = _ref35[3];

          return ["rotate3d(".concat(x2, ",").concat(y2, ",").concat(z2, ",").concat(addUnit(deg, unit2), ")"), isValueIdentity(deg, 0)];
        } : function (input) {
          return ["".concat(key, "(").concat(input.map(function (v) {
            return addUnit(v, unit2);
          }).join(","), ")"), isValueIdentity(input, key.startsWith("scale") ? 1 : 0)];
        });
      }
    });

    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }

    return _super11.call(this, style);
  }

  return _createClass(AnimatedStyle);
}(AnimatedObject);

var FluidTransform = /*#__PURE__*/function (_FluidValue2) {
  _inherits(FluidTransform, _FluidValue2);

  var _super12 = _createSuper(FluidTransform);

  function FluidTransform(inputs, transforms) {
    var _this25;

    _classCallCheck(this, FluidTransform);

    _this25 = _super12.call(this);
    _this25._value = null;
    _this25.inputs = inputs;
    _this25.transforms = transforms;
    return _this25;
  }

  _createClass(FluidTransform, [{
    key: "get",
    value: function get() {
      return this._value || (this._value = this._get());
    }
  }, {
    key: "_get",
    value: function _get() {
      var _this26 = this;

      var transform = "";
      var identity2 = true;
      each(this.inputs, function (input, i) {
        var arg1 = getFluidValue(input[0]);

        var _this26$transforms$i = _this26.transforms[i](is.arr(arg1) ? arg1 : input.map(getFluidValue)),
            _this26$transforms$i2 = _slicedToArray(_this26$transforms$i, 2),
            t = _this26$transforms$i2[0],
            id = _this26$transforms$i2[1];

        transform += " " + t;
        identity2 = identity2 && id;
      });
      return identity2 ? "none" : transform;
    }
  }, {
    key: "observerAdded",
    value: function observerAdded(count) {
      var _this27 = this;

      if (count == 1) each(this.inputs, function (input) {
        return each(input, function (value) {
          return hasFluidValue(value) && addFluidObserver(value, _this27);
        });
      });
    }
  }, {
    key: "observerRemoved",
    value: function observerRemoved(count) {
      var _this28 = this;

      if (count == 0) each(this.inputs, function (input) {
        return each(input, function (value) {
          return hasFluidValue(value) && removeFluidObserver(value, _this28);
        });
      });
    }
  }, {
    key: "eventObserved",
    value: function eventObserved(event) {
      if (event.type == "change") {
        this._value = null;
      }

      callFluidObservers(this, event);
    }
  }]);

  return FluidTransform;
}(FluidValue);

var primitives = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"];
var _excluded = ["scrollTop", "scrollLeft"];
globals.assign({
  batchedUpdates: unstable_batchedUpdates,
  createStringInterpolator: createStringInterpolator,
  colors: colors
});
var host = createHost(primitives, {
  applyAnimatedValues: applyAnimatedValues,
  createAnimatedStyle: function createAnimatedStyle(style) {
    return new AnimatedStyle(style);
  },
  getComponentProps: function getComponentProps(_ref) {
    var props = _objectWithoutPropertiesLoose(_ref, _excluded);

    return props;
  }
});
var animated = host.animated;

var defaultRenderPointer = function defaultRenderPointer(_ref36) {
  var color2 = _ref36.color,
      position = _ref36.position,
      value = _ref36.value;
  return /* @__PURE__ */jsx("svg", {
    width: "8",
    height: "8",
    viewBox: "0 0 8 8",
    style: {
      marginTop: -8
    },
    children: /* @__PURE__ */jsx("polygon", {
      points: "0,2 8,2 4,8 0,2",
      fill: color2
    })
  });
};

var Marker = function Marker(_g) {
  var _h = _g,
      className = _h.className,
      value = _h.value,
      pointerColor = _h.color,
      pointer = _h.pointer,
      _h$renderPointer = _h.renderPointer,
      renderPointer = _h$renderPointer === void 0 ? defaultRenderPointer : _h$renderPointer,
      children2 = _h.children,
      _h$style = _h.style,
      styleOverrides = _h$style === void 0 ? {} : _h$style,
      props = __objRest(_h, ["className", "value", "color", "pointer", "renderPointer", "children", "style"]);

  var _useScaleContext3 = useScaleContext(),
      type = _useScaleContext3.type,
      position = _useScaleContext3.position,
      color2 = _useScaleContext3.color,
      margin = _useScaleContext3.margin;

  var hasValue = value || Number.isFinite(value);
  var leftPosition = !hasValue ? 0 : type === "category" ? position(value) + position.bandwidth() / 2 : position(value);
  var markerColor = hasValue ? color2(value) : color2(0);
  var pointerElement = pointer && typeof renderPointer === "function" && renderPointer({
    color: pointerColor || markerColor,
    position: leftPosition,
    value: value
  });
  var markerProps = useSpring({
    left: leftPosition * 100 + "%",
    opacity: hasValue ? 1 : 0
  });
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    className: clsx("HypScale-markerRoot", className),
    style: __spreadValues({
      position: "relative",
      marginLeft: margin.left,
      marginRight: margin.right
    }, styleOverrides)
  }, props), {
    children: /* @__PURE__ */jsxs(animated.div, {
      className: clsx("HypScale-markerWrapper"),
      style: markerProps,
      children: [pointer && pointerElement && /* @__PURE__ */jsx("div", {
        className: "HypScale-pointerWrapper",
        children: pointerElement
      }), children2]
    })
  }));
};

Marker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pointerColor: PropTypes.string
};

var isMergeableObject = function isMergeableObject2(value) {
  return isNonNullObject(value) && !isSpecial(value);
};

function isNonNullObject(value) {
  return !!value && typeof value === "object";
}

function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}

var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;

function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}

function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}

function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }

  var customMerge = options.customMerge(key);
  return typeof customMerge === "function" ? customMerge : deepmerge;
}

function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}

function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}

function propertyIsOnObject(object2, property) {
  try {
    return property in object2;
  } catch (_) {
    return false;
  }
}

function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
}

function mergeObject(target, source, options) {
  var destination = {};

  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }

  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }

    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}

function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}

deepmerge.all = function deepmergeAll(array2, options) {
  if (!Array.isArray(array2)) {
    throw new Error("first argument should be an array");
  }

  return array2.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};

var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;
var defaultTheme = {
  bubble: {
    strokeWidth: 1
  },
  highlightBubble: {
    strokeWidth: 2
  },
  highlightLine: {},
  highlightText: {},
  text: {
    fontSize: 12,
    fill: "currentColor",
    textAnchor: "start",
    alignmentBaseline: "central",
    fillOpacity: 1
  },
  line: {
    stroke: "currentColor",
    strokeWidth: 1
  }
};

var getAnnotationPosition = function getAnnotationPosition(sizes, currentSize) {
  var sorted = sizes.slice().sort(function (a, b) {
    return a - b;
  });
  var currentIndex = sorted.findIndex(function (s) {
    return s === currentSize;
  });
  var previousHeight = currentIndex === 0 ? 0 : sizes[currentIndex - 1] * 2;
  var currentHeight = currentSize * 2;
  return (currentHeight - previousHeight) / 2 + previousHeight;
};

var Bubble = function Bubble(_i) {
  var _j = _i,
      cx = _j.cx,
      cy = _j.cy,
      size = _j.size,
      label = _j.label,
      labelY = _j.labelY,
      labelX = _j.labelX,
      fill = _j.fill,
      stroke = _j.stroke,
      _j$theme = _j.theme,
      theme = _j$theme === void 0 ? {
    bubble: {},
    line: {},
    text: {}
  } : _j$theme,
      props = __objRest(_j, ["cx", "cy", "size", "label", "labelY", "labelX", "fill", "stroke", "theme"]);

  var hasLabel = label || Number.isFinite(label);
  var circleProps = useSpring({
    cx: cx,
    cy: cy,
    r: size,
    fill: fill,
    stroke: stroke
  });
  var lineProps = useSpring({
    x1: cx,
    x2: labelX,
    y1: labelY || 0,
    y2: labelY || 0
  });
  var textProps = useSpring({
    x: labelX + 8,
    y: labelY || 0
  });
  return /* @__PURE__ */jsxs("g", __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */jsx(animated.circle, __spreadProps(__spreadValues({}, circleProps), {
      fill: "#fff",
      fillOpacity: "1"
    })), /* @__PURE__ */jsx(animated.circle, __spreadValues(__spreadValues({
      fill: fill,
      stroke: stroke
    }, circleProps), theme.bubble)), hasLabel && /* @__PURE__ */jsx(animated.line, __spreadValues(__spreadValues({}, lineProps), theme.line)), hasLabel && /* @__PURE__ */jsx(animated.text, __spreadProps(__spreadValues(__spreadValues({}, textProps), theme.text), {
      children: label
    }))]
  }));
};

var Bubbles = function Bubbles(_k) {
  var _l = _k,
      count = _l.count,
      minSize = _l.minSize,
      maxSize = _l.maxSize,
      margin = _l.margin,
      lineLength = _l.lineLength,
      highlight = _l.highlight,
      formatLabel = _l.formatLabel,
      providedTheme = _l.theme,
      fillOpacity = _l.fillOpacity,
      children2 = _l.children,
      props = __objRest(_l, ["count", "minSize", "maxSize", "margin", "lineLength", "highlight", "formatLabel", "theme", "fillOpacity", "children"]);

  var _useScaleContext4 = useScaleContext(),
      color2 = _useScaleContext4.color,
      chunks = _useScaleContext4.chunks,
      size = _useScaleContext4.size;

  var theme = cjs(defaultTheme, providedTheme);
  var mx = margin.left + margin.right;
  var my = margin.top + margin.bottom;
  var maxRadius = maxSize / 2;
  var width = maxSize + lineLength;
  var height = maxSize;
  var scale = size;
  var colorScale = color2;
  var sizes = chunks;
  var hasHighlight = Number.isFinite(highlight);
  var highlightSize = scale(highlight) / 2;
  var highlightYPos = highlight && height - getAnnotationPosition([highlightSize], highlightSize);
  var highlightColor = hasHighlight ? colorScale(scale.invert(highlightSize * 2)) : "transparent";
  var containerStyle = useSpring({
    opacity: hasHighlight ? 0.2 : 1
  });
  return /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: width + mx,
    height: height + my,
    className: clsx("HypBubble-root", {
      "HypBubble-highlighted": highlight
    })
  }, props), {
    children: [/* @__PURE__ */jsx(animated.g, __spreadProps(__spreadValues({
      className: "HypBubble-bubbles",
      transform: "translate(".concat(margin.left, ",").concat(margin.top, ")")
    }, containerStyle), {
      children: sizes.slice().reverse().map(function (s, i) {
        var yPos = height - getAnnotationPosition(sizes, s);
        var color22 = colorScale(scale.invert(s * 2));
        return /* @__PURE__ */jsx(Bubble, {
          className: "HypBubble-bubble",
          cx: maxRadius,
          cy: height - s,
          size: s,
          label: !highlight && formatLabel(scale.invert(s * 2)),
          labelX: maxRadius * 2 + lineLength,
          labelY: yPos,
          stroke: color22,
          fill: color22,
          fillOpacity: fillOpacity,
          theme: theme
        }, s);
      })
    })), /* @__PURE__ */jsx(Bubble, {
      className: "HypBubble-highlight",
      transform: "translate(".concat(margin.left, ",").concat(margin.top, ")"),
      cx: maxRadius,
      cy: hasHighlight ? height - highlightSize : height,
      size: hasHighlight ? highlightSize : 0,
      label: hasHighlight && formatLabel(highlight),
      labelY: hasHighlight && highlightYPos,
      labelX: maxRadius * 2 + lineLength,
      fillOpacity: fillOpacity,
      fill: highlightColor,
      stroke: highlightColor,
      theme: {
        line: __spreadValues(__spreadValues({}, theme.line), theme.highlightLine),
        bubble: __spreadValues(__spreadValues({}, theme.bubble), theme.highlightBubble),
        text: __spreadValues(__spreadValues({}, theme.text), theme.highlightText)
      },
      style: {
        color: hasHighlight ? void 0 : "transparent"
      }
    }), children2]
  }));
};

Bubbles.defaultProps = {
  minSize: 8,
  maxSize: 48,
  margin: {
    top: 1,
    right: 48,
    bottom: 1,
    left: 1
  },
  theme: {},
  lineLength: 16,
  formatLabel: function formatLabel(d) {
    return d;
  }
};
Bubbles.propTypes = {
  minSize: PropTypes.number,
  maxSize: PropTypes.number,
  margin: PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number
  }),
  lineLength: PropTypes.number,
  formatLabel: PropTypes.func,
  highlight: PropTypes.number,
  theme: PropTypes.shape({
    bubble: PropTypes.object,
    line: PropTypes.object,
    text: PropTypes.object
  })
};

var FORMAT_RANGE = function FORMAT_RANGE(value, entryIndex, total) {
  if (!Array.isArray(value)) return value;
  if (entryIndex === 0) return "< ".concat(value[1]);
  if (entryIndex === total - 1) return "> ".concat(value[0]);
  if (Array.isArray(value) && value.length === 2) return "".concat(value[0], " - ").concat(value[1]);
  return value;
};

var Chunks = function Chunks(_m) {
  var _n = _m,
      formatLabel = _n.formatLabel,
      className = _n.className,
      props = __objRest(_n, ["formatLabel", "className"]);

  var _useScaleContext5 = useScaleContext(),
      chunks = _useScaleContext5.chunks;

  if (!chunks) return null;
  return /* @__PURE__ */jsx("ul", __spreadProps(__spreadValues({
    className: clsx("HypScale-chunkList", className)
  }, props), {
    children: chunks.map(function (chunk, i) {
      return /* @__PURE__ */jsxs("li", {
        className: "HypScale-chunkListItem",
        children: [/* @__PURE__ */jsx("span", {
          className: "HypScale-chunkMarker",
          "aria-hidden": "true",
          style: {
            background: chunk.color
          }
        }), /* @__PURE__ */jsx("span", {
          className: "HypScale-chunkLabel",
          children: formatLabel(chunk.value, i, chunks.length)
        })]
      }, i);
    })
  }));
};

Chunks.defaultProps = {
  formatLabel: FORMAT_RANGE
};
Chunks.propTypes = {
  formatLabel: PropTypes.func
};
var Scale$1 = "";
var DEFAULT_MARGIN = {
  top: 0,
  bottom: 0,
  left: 8,
  right: 8
};
var ScaleContext = React__default.createContext();

function useScaleContext() {
  var context = React__default.useContext(ScaleContext);

  if (!context) {
    throw new Error("Scale compound components cannot be rendered outside the Scale component");
  }

  return context;
}

var Scale = function Scale(_o) {
  var _p = _o,
      data = _p.data,
      colors2 = _p.colors,
      accessor = _p.accessor,
      nice = _p.nice,
      thresholds = _p.thresholds,
      chunks = _p.chunks,
      _p$width = _p.width,
      width = _p$width === void 0 ? 280 : _p$width,
      type = _p.type,
      _p$margin = _p.margin,
      margin = _p$margin === void 0 ? DEFAULT_MARGIN : _p$margin,
      min = _p.min,
      max = _p.max,
      categories = _p.categories,
      children2 = _p.children,
      className = _p.className,
      _p$reverse = _p.reverse,
      reverse = _p$reverse === void 0 ? false : _p$reverse,
      props = __objRest(_p, ["data", "colors", "accessor", "nice", "thresholds", "chunks", "width", "type", "margin", "min", "max", "categories", "children", "className", "reverse"]);

  var options = useMemo(function () {
    return {
      accessor: accessor,
      thresholds: thresholds,
      chunks: chunks,
      nice: nice,
      min: min,
      max: max,
      categories: categories,
      reverse: reverse
    };
  }, [accessor, thresholds, chunks, nice, min, max, categories, reverse]);
  var value = useMemo(function () {
    var _a;

    var scales = getScale(type, __spreadValues({
      data: data,
      colors: colors2
    }, options));
    var extent2 = (_a = scales == null ? void 0 : scales.position) == null ? void 0 : _a.domain();
    return __spreadValues({
      width: width,
      type: type,
      margin: margin,
      colors: colors2,
      data: data,
      thresholds: thresholds,
      extent: extent2,
      chunks: chunks,
      reverse: reverse
    }, scales);
  }, [width, colors2, thresholds, type, margin, chunks, data, options]);
  return /* @__PURE__ */jsx(ScaleContext.Provider, {
    value: value,
    children: /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
      className: clsx("HypScale-root", className),
      style: {
        width: width
      }
    }, props), {
      children: children2
    }))
  });
};

Scale.propTypes = {
  type: PropTypes.oneOf(["category", "continuous", "quantize", "quantile", "threshold", "bubble"]),
  width: PropTypes.number,
  colors: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  margin: PropTypes.object,
  nice: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.object])),
  accessor: PropTypes.func,
  thresholds: PropTypes.arrayOf(PropTypes.number),
  chunks: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number
};
Scale.Colors = Colors;
Scale.Ticks = Ticks;
Scale.Marker = Marker;
Scale.Bubbles = Bubbles;
Scale.Chunks = Chunks;
export { Scale, getBubbleScale, getBubbleSizes, getCategoryChunks, getCategoryScale, getChunks, getColorInterpolator, getColorScale, getColors, getContinuousScale, getExtent, getGroups, getPositionScale, getQuantileScale, getQuantizeScale, getScale, getThresholdScale, isContinuous, useScaleContext };